
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1wGp6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ivUmx = parcelRequire("ivUmx");

// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $02d82ee539c4226d$var$ROOT_MARGIN_VERTICAL = '360px';
const $02d82ee539c4226d$var$useIntersectionObserver = ({ onIntersecting: onIntersectingCallback, onIntersection: onIntersectionCallback })=>{
    const ref = (0, $42omo.useRef)(null);
    const onIntersectingCallbackRef = (0, $42omo.useRef)(onIntersectingCallback);
    const onIntersectionCallbackRef = (0, $42omo.useRef)(onIntersectionCallback);
    (0, $42omo.useEffect)(()=>{
        onIntersectingCallbackRef.current = onIntersectingCallback;
        onIntersectionCallbackRef.current = onIntersectionCallback;
    }, [
        onIntersectingCallback,
        onIntersectionCallback
    ]);
    const onIntersection = (0, $42omo.useCallback)((entries, observer)=>{
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        onIntersectionCallbackRef.current?.(isIntersecting);
        if (isIntersecting) {
            onIntersectingCallbackRef.current?.();
            observer.disconnect();
        }
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!(0, $ivUmx.isIntersectionObserverSupported)() || !ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$02d82ee539c4226d$var$ROOT_MARGIN_VERTICAL} 0px ${$02d82ee539c4226d$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    return ref;
};
var $02d82ee539c4226d$export$2e2bcd8739ae039 = $02d82ee539c4226d$var$useIntersectionObserver;
module.exports["default"] = $02d82ee539c4226d$export$2e2bcd8739ae039;

});

parcelRegister("7hy9e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kKODE = parcelRequire("kKODE");


var $5MkWK = parcelRequire("5MkWK");


var $9E8aG = parcelRequire("9E8aG");

function $7ad7ce53cd66ff9c$export$c721b83ca330cb86({ appearance: appearance, children: children, id: id, ui: ui, url: url = '' }) {
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { getByUrl: getByUrl } = (0, $5MkWK.useSmartLinkAnalyticsUtils)();
    const getAnalyticsProps = (0, $42omo.useCallback)(()=>{
        const isFlexibleUi = (0, $9E8aG.isFlexibleUiCard)(children, ui);
        const display = isFlexibleUi ? 'flexible' : appearance;
        return {
            display: display,
            id: id
        };
    }, [
        appearance,
        children,
        id,
        ui
    ]);
    const statusRef = (0, $42omo.useRef)();
    const analyticsPropsRef = (0, $42omo.useRef)(null);
    const hasIntersectedRef = (0, $42omo.useRef)(false);
    const hasFiredSeenRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        analyticsPropsRef.current = getAnalyticsProps();
    }, [
        getAnalyticsProps
    ]);
    const maybeFireSeenEvent = (0, $42omo.useCallback)(()=>{
        if (!hasFiredSeenRef.current && hasIntersectedRef.current && statusRef.current === 'unauthorized') {
            const payload = getByUrl(url, analyticsPropsRef.current);
            fireEvent('ui.smartLink.seen', payload?.attributes);
            hasFiredSeenRef.current = true;
        }
    }, [
        fireEvent,
        getByUrl,
        url
    ]);
    const onIntersecting = (0, $42omo.useCallback)(()=>{
        if (hasIntersectedRef.current) return;
        hasIntersectedRef.current = true;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    const onStatusSettled = (0, $42omo.useCallback)((status)=>{
        statusRef.current = status;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    return (0, $42omo.useMemo)(()=>({
            onIntersecting: onIntersecting,
            onStatusSettled: onStatusSettled
        }), [
        onIntersecting,
        onStatusSettled
    ]);
}
module.exports["useSmartLinkSeenEvent"] = $7ad7ce53cd66ff9c$export$c721b83ca330cb86;

});

parcelRegister("6tOCz", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $075bd5fa1c8d49d5$var$CardLoaderWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance, children: children }, ref)=>{
    const Component = appearance === 'inline' ? 'span' : 'div';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        className: "loader-wrapper",
        ref: ref
    }, children));
});
var $075bd5fa1c8d49d5$export$2e2bcd8739ae039 = $075bd5fa1c8d49d5$var$CardLoaderWrapper;
module.exports["default"] = $075bd5fa1c8d49d5$export$2e2bcd8739ae039;

});

parcelRegister("aylI0", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $a1WXB = parcelRequire("a1WXB");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");





var $eIleF = parcelRequire("eIleF");


var $a43ao = parcelRequire("a43ao");




const $390b027c3f7a5938$export$5d10838c1e539409 = ()=>{
    const context = (0, $eIleF.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};



var $4QzTV = parcelRequire("4QzTV");


var $lz9QA = parcelRequire("lz9QA");

function $76aaca0831a6f2dc$export$9f4e486b1dc3e700(id, url) {
    const state = (0, $lz9QA.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $eIleF.useSmartLinkContext)();
    const actions = (0, $a43ao.useSmartCardActions)(id, url);
    const config = (0, $390b027c3f7a5938$export$5d10838c1e539409)();
    const renderers = (0, $4QzTV.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $42omo.useState)(null);
    // Register the current card.
    const register = ()=>{
        actions.register().catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $42omo.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel
    };
}



var $bIll3 = parcelRequire("bIll3");


var $226XV = parcelRequire("226XV");


var $8qPK2 = parcelRequire("8qPK2");


var $3eMTN = parcelRequire("3eMTN");


var $ivUmx = parcelRequire("ivUmx");

const $8b4d30aa6042b620$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};



var $6wQZE = parcelRequire("6wQZE");


var $5MkWK = parcelRequire("5MkWK");


var $k3uJF = parcelRequire("k3uJF");


var $9E8aG = parcelRequire("9E8aG");


var $l6tPN = parcelRequire("l6tPN");





var $fwDOR = parcelRequire("fwDOR");







const $00d3b0f3bfadf328$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $eIleF.useSmartLinkContext)();
    return (0, $42omo.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};


const $d51bcf9a409e676a$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));



var $izGro = parcelRequire("izGro");


var $1KuCI = parcelRequire("1KuCI");





var $ebrpi = parcelRequire("ebrpi");


var $afp1H = parcelRequire("afp1H");


var $aIzVM = parcelRequire("aIzVM");





var $aXWIB = parcelRequire("aXWIB");







const $a68353b540d2e9d3$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $5TXU5.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).try_again),
        testId: 'smart-action-try-again'
    });


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $4P6U3 = parcelRequire("4P6U3");


var $8k046 = parcelRequire("8k046");


var $2R1C4 = parcelRequire("2R1C4");

var $jsdg1 = parcelRequire("jsdg1");

var $Y5kOr = parcelRequire("Y5kOr");

var $5znEc = parcelRequire("5znEc");





var $imb12 = parcelRequire("imb12");




const $f52e364f0b2ceb52$var$baseTopMetadata = [
    {
        name: (0, $5TXU5.ElementName).ModifiedOn
    },
    {
        name: (0, $5TXU5.ElementName).AttachmentCount
    },
    {
        name: (0, $5TXU5.ElementName).SubscriberCount
    },
    {
        name: (0, $5TXU5.ElementName).VoteCount
    },
    {
        name: (0, $5TXU5.ElementName).DueOn
    },
    {
        name: (0, $5TXU5.ElementName).ReadTime
    }
];
const $f52e364f0b2ceb52$var$baseBottomMetaData = [
    {
        name: (0, $5TXU5.ElementName).ReactCount
    },
    {
        name: (0, $5TXU5.ElementName).CommentCount
    },
    {
        name: (0, $5TXU5.ElementName).ViewCount
    },
    {
        name: (0, $5TXU5.ElementName).Priority
    },
    {
        name: (0, $5TXU5.ElementName).SubTasksProgress
    },
    {
        name: (0, $5TXU5.ElementName).ChecklistProgress
    }
];
const $f52e364f0b2ceb52$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $226XV.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $5TXU5.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $5TXU5.ElementName).AuthorGroup
        },
        {
            name: (0, $5TXU5.ElementName).CreatedBy
        },
        ...$f52e364f0b2ceb52$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $f52e364f0b2ceb52$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $5TXU5.ElementName).LatestCommit
                    },
                    {
                        name: (0, $5TXU5.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $5TXU5.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $imb12.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5TXU5.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5TXU5.ElementName).OwnedBy
                    },
                    ...$f52e364f0b2ceb52$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).AppliedToComponentsCount
                    },
                    ...$f52e364f0b2ceb52$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $imb12.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5TXU5.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5TXU5.ElementName).OwnedBy
                    },
                    ...$f52e364f0b2ceb52$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).AppliedToComponentsCount
                    },
                    ...$f52e364f0b2ceb52$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $imb12.extractOwnedBy)(data) ? [
                    {
                        name: (0, $5TXU5.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $5TXU5.ElementName).OwnedBy
                    },
                    ...$f52e364f0b2ceb52$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $5TXU5.ElementName).AuthorGroup
                },
                {
                    name: (0, $5TXU5.ElementName).CreatedBy
                },
                {
                    name: (0, $5TXU5.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $5TXU5.ElementName).AssignedToGroup
                },
                {
                    name: (0, $5TXU5.ElementName).AssignedTo
                },
                {
                    name: (0, $5TXU5.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $5TXU5.ElementName).OwnedByGroup
                },
                {
                    name: (0, $5TXU5.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).StoryPoints
                    },
                    {
                        name: (0, $5TXU5.ElementName).Priority
                    },
                    {
                        name: (0, $5TXU5.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5TXU5.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).ReactCount
                    },
                    {
                        name: (0, $5TXU5.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).CollaboratorGroup
                    },
                    ...$f52e364f0b2ceb52$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $5TXU5.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $5TXU5.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $5TXU5.ElementName).UserAttributes
                    },
                    ...$f52e364f0b2ceb52$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $f52e364f0b2ceb52$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $f52e364f0b2ceb52$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $5TXU5.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $5TXU5.SmartLinkSize).Large
};
const $f52e364f0b2ceb52$export$9671929f11bd4ad8 = {
    placement: (0, $5TXU5.MediaPlacement).Right,
    ignoreContainerPadding: true
};


const $73210084318df45d$var$customBlockStyles = null;
const $73210084318df45d$var$titleBlockCss = null;
const $73210084318df45d$var$footerBlockCss = null;
const $73210084318df45d$var$footerBlockSafariStyles = null;
const $73210084318df45d$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $42omo.useMemo)(()=>(0, $4P6U3.browser)(), []);
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $f52e364f0b2ceb52$export$22ebf74c8bee4708),
        url: url
    }, /*#__PURE__*/ $42omo.createElement((0, $5znEc.default), {
        ...(0, $f52e364f0b2ceb52$export$45bdb4108909a713),
        hideIcon: !!title,
        text: title,
        CompetitorPrompt: CompetitorPrompt,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _13mh1pd9 _2yhz13af"
        ])
    }), /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc0i7uo"
        ])
    }, children), showPreview && /*#__PURE__*/ $42omo.createElement((0, $Y5kOr.default), (0, $f52e364f0b2ceb52$export$9671929f11bd4ad8)), /*#__PURE__*/ $42omo.createElement((0, $jsdg1.default), {
        actions: actions,
        testId: "smart-block-card-footer",
        className: (0, $gMc0m.default)([
            "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
            safari && "_4t3i1osq"
        ])
    }));
};
var $73210084318df45d$export$2e2bcd8739ae039 = $73210084318df45d$var$UnresolvedView;


/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $53d96f90b9ec11b4$var$flexibleBlockCardStyle = null;
const $53d96f90b9ec11b4$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                "_1g961mok _1qo3ia51"
            ])
        }, /*#__PURE__*/ $42omo.createElement(FlexibleBlockCardView, props));
    };


/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $e4bb3a6bbb490086$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $42omo.useMemo)(()=>props.onAuthorize ? [
            (0, $a68353b540d2e9d3$export$c527d977b53f7537)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $73210084318df45d$export$2e2bcd8739ae039), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "errored-warning-icon",
        color: "var(--ds-icon-warning, #E06C00)",
        testId: `${testId}-warning-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aIzVM.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $afp1H.messages).could_not_load_link
        }
    }));
};
const $e4bb3a6bbb490086$var$_default_1 = (0, $53d96f90b9ec11b4$export$36ce1a3a446661ab)($e4bb3a6bbb490086$var$ErroredView);
var $e4bb3a6bbb490086$export$2e2bcd8739ae039 = $e4bb3a6bbb490086$var$_default_1;


/* ForbiddenView.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $9Q2dU = parcelRequire("9Q2dU");





var $7kN5H = parcelRequire("7kN5H");


var $hiPTU = parcelRequire("hiPTU");







const $70f63e68a5826333$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $afp1H.messages)) return (0, $afp1H.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};



var $4ibS1 = parcelRequire("4ibS1");
















const $13d49f71064ce6e4$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $5TXU5.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $afp1H.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });




const $e0dd06a6bd5fc7bf$var$textStyles = null; /**
                          * This view represent a Block Card with the 'Forbidden' status.
                          * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
                          *
                          * @see SmartLinkStatus
                          * @see FlexibleCardProps
                          */ 
const $e0dd06a6bd5fc7bf$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $aXWIB.useIntl)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $4ibS1.getForbiddenJsonLd)().meta;
    const provider = (0, $a1WXB.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $42omo.useMemo)(()=>{
        const hostname = /*#__PURE__*/ $42omo.createElement("b", null, (0, $hiPTU.default)(url));
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $42omo.useMemo)(()=>{
        return (0, $7kN5H.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $42omo.useMemo)(()=>{
        const descriptor = (0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $42omo.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $13d49f71064ce6e4$export$59f8830fb5467e35)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $13d49f71064ce6e4$export$59f8830fb5467e35)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $73210084318df45d$export$2e2bcd8739ae039), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: "forbidden-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $42omo.createElement((0, $aIzVM.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
            values: messageContext
        },
        className: (0, $gMc0m.default)([
            "_syazi7uo"
        ])
    }));
};
const $e0dd06a6bd5fc7bf$var$_default_1 = (0, $53d96f90b9ec11b4$export$36ce1a3a446661ab)($e0dd06a6bd5fc7bf$var$ForbiddenView);
var $e0dd06a6bd5fc7bf$export$2e2bcd8739ae039 = $e0dd06a6bd5fc7bf$var$_default_1;


/* NotFoundView.tsx generated by @compiled/babel-plugin v0.36.1 */ 






















const $464ca6acd99b1f7c$var$textStyles = null; /**
                          * This view represents a Block Card with a 'Not_Found' status.
                          *
                          * @see SmartLinkStatus
                          * @see FlexibleCardProps
                          */ 
const $464ca6acd99b1f7c$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { cardState: { details: details } } = props;
    const product = (0, $42omo.useMemo)(()=>{
        const provider = (0, $a1WXB.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $42omo.useMemo)(()=>intl.formatMessage((0, $afp1H.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $42omo.useMemo)(()=>({
            descriptor: (0, $afp1H.messages).not_found_description
        }), []);
    return /*#__PURE__*/ $42omo.createElement((0, $73210084318df45d$export$2e2bcd8739ae039), {
        ...props,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: "not-found-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $42omo.createElement((0, $aIzVM.default), {
        message: description,
        testId: `${testId}-message`,
        maxLines: 3,
        className: (0, $gMc0m.default)([
            "_syazi7uo"
        ])
    }));
};
const $464ca6acd99b1f7c$var$_default_1 = (0, $53d96f90b9ec11b4$export$36ce1a3a446661ab)($464ca6acd99b1f7c$var$NotFoundView);
var $464ca6acd99b1f7c$export$2e2bcd8739ae039 = $464ca6acd99b1f7c$var$_default_1;


/* ResolvedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $9CUIX = parcelRequire("9CUIX");





var $k9nkv = parcelRequire("k9nkv");


var $l17Fn = parcelRequire("l17Fn");





var $1MuZd = parcelRequire("1MuZd");


var $8NpDA = parcelRequire("8NpDA");

var $1lLfV = parcelRequire("1lLfV");



var $8zS2j = parcelRequire("8zS2j");





const $b2f9c513d2386c05$var$titleBlockCss = null;
const $b2f9c513d2386c05$var$footerBlockCss = null;
const $b2f9c513d2386c05$var$footerExtraSpacingCss = null;
const $b2f9c513d2386c05$var$footerBlockSafariStyles = null; /**
                                       * This view represents a Block card that has an 'Resolved' status.
                                       * @see SmartLinkStatus
                                       * @see FlexibleCardProps
                                       */ 
const $b2f9c513d2386c05$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $42omo.useState)(false);
    const extensionKey = (0, $226XV.getExtensionKey)(cardState.details);
    const { isEnabled: is3PRovoBlockExperimentEnabled } = (0, $k9nkv.default)(url, actionOptions);
    const rovoConfig = is3PRovoBlockExperimentEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $l17Fn.default)() : undefined;
    const showRovoResolvedView = is3PRovoBlockExperimentEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $42omo.useMemo)(()=>cardState?.status === 'resolved' && cardState.details && (0, $9CUIX.default)({
            response: cardState.details,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions
        }) !== undefined, [
        actionOptions,
        cardState?.details,
        cardState?.status,
        rovoConfig
    ]) : undefined; // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $42omo.useMemo)(()=>(0, $4P6U3.browser)(), []);
    (0, $42omo.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $f52e364f0b2ceb52$export$f87d357259b3b7c8)(cardState.details);
    const prompts = (0, $42omo.useMemo)(()=>{
        if (is3PRovoBlockExperimentEnabled) {
            const defaultPrompts = [
                (0, $1MuZd.RovoChatPromptKey).KEY_HIGHLIGHTS
            ];
            const linkType = cardState.details?.data?.['@type'];
            if (extensionKey === 'slack-object-provider') return [
                (0, $1MuZd.RovoChatPromptKey).FIND_OPEN_QUESTIONS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType?.includes('schema:PresentationDigitalDocument')) return [
                (0, $1MuZd.RovoChatPromptKey).IDENTIFY_KEY_POINTS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType?.includes('schema:SpreadsheetDigitalDocument')) return [
                (0, $1MuZd.RovoChatPromptKey).IDENTIFY_KEY_TRENDS,
                ...defaultPrompts
            ];
            return [
                (0, $1MuZd.RovoChatPromptKey).SUMMARIZE_LINK,
                ...defaultPrompts
            ];
        }
        return [];
    }, [
        cardState?.details?.data,
        extensionKey,
        is3PRovoBlockExperimentEnabled
    ]);
    const footerActions = (0, $42omo.useMemo)(()=>showRovoResolvedView && is3PRovoBlockExperimentEnabled ? [
            {
                name: (0, $5TXU5.ActionName).RovoChatAction,
                prompts: prompts,
                iconSize: 'small',
                cardAppearance: (0, $5TXU5.CardDisplay).Block
            },
            {
                name: (0, $5TXU5.ActionName).FollowAction,
                iconSize: 'small'
            },
            {
                name: (0, $5TXU5.ActionName).DownloadAction,
                iconSize: 'small'
            }
        ] : [
            {
                name: (0, $5TXU5.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $5TXU5.ActionName).DownloadAction,
                hideIcon: true
            }
        ], [
        showRovoResolvedView,
        prompts,
        is3PRovoBlockExperimentEnabled
    ]);
    const uiOptions = (0, $f52e364f0b2ceb52$export$22ebf74c8bee4708);
    uiOptions.enableSnippetRenderer = true;
    uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url
    }, /*#__PURE__*/ $42omo.createElement((0, $5znEc.default), {
        ...(0, $f52e364f0b2ceb52$export$45bdb4108909a713),
        metadata: titleMetadata,
        subtitle: [
            {
                name: (0, $5TXU5.ElementName).Location
            }
        ],
        metadataPosition: (0, $5TXU5.SmartLinkPosition).Top,
        CompetitorPrompt: CompetitorPrompt,
        url: url,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _13mh1pd9 _2yhz13af"
        ])
    }), /*#__PURE__*/ $42omo.createElement((0, $1lLfV.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ $42omo.createElement((0, $8zS2j.default), null), /*#__PURE__*/ $42omo.createElement((0, $1lLfV.default), {
        primary: bottomMetadata,
        maxLines: 1
    }), !isPreviewBlockErrored ? /*#__PURE__*/ $42omo.createElement((0, $Y5kOr.default), {
        ...(0, $f52e364f0b2ceb52$export$9671929f11bd4ad8),
        onError: ()=>{
            setIsPreviewBlockErrored(true);
        }
    }) : null, /*#__PURE__*/ $42omo.createElement((0, $8NpDA.default), {
        actions: footerActions,
        isPreviewBlockErrored: isPreviewBlockErrored,
        className: (0, $gMc0m.default)([
            "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
            safari && "_4t3i1osq",
            (0, $dh538.fg)('platform_navx_block_card_footer_spacing') && "_19pku2gc"
        ])
    }));
};
const $b2f9c513d2386c05$var$_default_1 = (0, $53d96f90b9ec11b4$export$36ce1a3a446661ab)($b2f9c513d2386c05$var$ResolvedView);
var $b2f9c513d2386c05$export$2e2bcd8739ae039 = $b2f9c513d2386c05$var$_default_1;


/* UnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $fBMbo = parcelRequire("fBMbo");


var $bYRk6 = parcelRequire("bYRk6");








var $bedQP = parcelRequire("bedQP");


var $gdv5Z = parcelRequire("gdv5Z");











var $fUfR2 = parcelRequire("fUfR2");











var $bIwjt = parcelRequire("bIwjt");


var $6xy7N = parcelRequire("6xy7N");










const $002c92f28b87e2dd$var$NOT_ENABLED_RESULT = {
    connectedPct: undefined,
    isEnabled: false,
    isLoading: false
};
/**
 * Cache-first social proof hook.
 *
 * On mount:
 * 1. Reads localStorage synchronously via `getProviderPctMapSync`.
 *    - If data exists (warm cache): sets `providerPctMap` immediately, `isLoading = false`.
 *    - If no data (cold cache): leaves `providerPctMap` undefined, `isLoading = false`.
 * 2. Always kicks off an async fetch (fire-and-forget) via `getProviderPctMap` to populate
 *    localStorage for next page load. Does NOT update state with the async result.
 *
 * This means:
 * - First page visit (cold): no social proof rendered, no experiment exposure fired.
 *   Background fetch populates localStorage for next time.
 * - Second page visit (warm): social proof renders immediately from localStorage.
 *   Background refresh keeps localStorage fresh.
 *
 * Callers decide separately (e.g. via Statsig experiment) whether to surface the data.
 */ const $002c92f28b87e2dd$var$useSocialProof = (extensionKey, isKillswitchOn = false, baseUriWithNoTrailingSlash = '')=>{
    const isEnabled = isKillswitchOn;
    const [snapshot] = (0, $42omo.useState)(()=>{
        if (!isEnabled) return {
            cloudId: undefined,
            providerPctMap: null
        };
        const cloudId = (0, $bIwjt.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
        return {
            cloudId: cloudId,
            providerPctMap: (0, $6xy7N.getProviderPctMapSync)(cloudId, (0, $6xy7N.SOCIAL_PROOF_TRAIT_NAME))
        };
    });
    // Fire-and-forget: warm caches for future mounts only. Never update this mount's treatment UI.
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled) return;
        (0, $bIwjt.getCurrentSiteCloudId)(baseUriWithNoTrailingSlash).then((cloudId)=>{
            (0, $6xy7N.getProviderPctMap)(cloudId, (0, $6xy7N.SOCIAL_PROOF_TRAIT_NAME));
        });
    }, [
        baseUriWithNoTrailingSlash,
        isEnabled
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!isEnabled) return $002c92f28b87e2dd$var$NOT_ENABLED_RESULT;
        return {
            connectedPct: extensionKey && snapshot.providerPctMap ? snapshot.providerPctMap[extensionKey] : undefined,
            isEnabled: Boolean(snapshot.cloudId && snapshot.providerPctMap),
            isLoading: false
        };
    }, [
        extensionKey,
        isEnabled,
        snapshot
    ]);
};
var $002c92f28b87e2dd$export$2e2bcd8739ae039 = $002c92f28b87e2dd$var$useSocialProof;


const $e1d4aa1e050b8c9a$export$4d1c9f059e1da2cc = 'social_proof_3p_unauth_block_exp';
const $e1d4aa1e050b8c9a$export$9f0628890f2ea4ef = 'platform_sl_3p_preauth_social_proof_inline_cta';
const $e1d4aa1e050b8c9a$export$e85fe820223563f3 = 30;
const $e1d4aa1e050b8c9a$export$adbe2edcab243434 = (connectedPct)=>{
    if (connectedPct === undefined) return undefined;
    return connectedPct >= $e1d4aa1e050b8c9a$export$e85fe820223563f3 ? 'not-low' : 'low';
};
const $e1d4aa1e050b8c9a$var$getSocialProofExperimentMetadata = ({ extensionKey: extensionKey, baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash = '' })=>{
    if (!extensionKey) return {
        isEligible: false
    };
    const cloudId = (0, $bIwjt.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
    const providerPctMap = (0, $6xy7N.getProviderPctMapSync)(cloudId, (0, $6xy7N.SOCIAL_PROOF_TRAIT_NAME));
    const tier = $e1d4aa1e050b8c9a$export$adbe2edcab243434(providerPctMap?.[extensionKey]);
    return {
        isEligible: tier !== undefined,
        ...tier ? {
            tier: tier
        } : {}
    };
};
const $e1d4aa1e050b8c9a$export$49fab64ef7e3aab7 = (params)=>({
        [$e1d4aa1e050b8c9a$export$4d1c9f059e1da2cc]: $e1d4aa1e050b8c9a$var$getSocialProofExperimentMetadata(params)
    });
const $e1d4aa1e050b8c9a$export$e53e13aaa7d7b805 = (params)=>({
        [$e1d4aa1e050b8c9a$export$9f0628890f2ea4ef]: $e1d4aa1e050b8c9a$var$getSocialProofExperimentMetadata(params)
    });
/**
 * Returns enrollment and treatment state for the social proof unauth block card experiment.
 *
 * Delegates data-fetching to `useSocialProof` (Sasha's shared service layer),
 * which handles cloudId resolution, TAP trait fetch, localStorage caching,
 * request deduping, and sync reads.
 *
 * This hook adds the experiment/cohort layer on top:
 * - Only fires exposure (via editorExperiment) when data has loaded.
 * - Derives `tier` and `isTreatment` for rendering decisions.
 *
 * Expected to be called only inside the fg-enabled branch (via componentWithFG).
 *
 * @param extensionKey - The extensionKey of the current 3P provider (e.g. 'google-object-provider').
 */ const $e1d4aa1e050b8c9a$var$useSocialProofExperiment = (extensionKey, baseUriWithNoTrailingSlash = '')=>{
    const { connectedPct: connectedPct, isEnabled: isEnabled, isLoading: isLoading } = (0, $002c92f28b87e2dd$export$2e2bcd8739ae039)(extensionKey, true, baseUriWithNoTrailingSlash);
    return (0, $42omo.useMemo)(()=>{
        const hasSocialProofData = connectedPct !== undefined;
        // Only fire exposure when data has loaded (prevents exposure inflation)
        const isTreatment = isEnabled && !isLoading && hasSocialProofData ? (0, $1oCLl.expValEquals)($e1d4aa1e050b8c9a$export$4d1c9f059e1da2cc, 'isEnabled', true) : false;
        const tier = $e1d4aa1e050b8c9a$export$adbe2edcab243434(connectedPct) ?? 'low';
        return {
            isTreatment: isTreatment,
            tier: tier,
            connectedPct: connectedPct,
            isLoading: isLoading
        };
    }, [
        isEnabled,
        isLoading,
        connectedPct
    ]);
};
var $e1d4aa1e050b8c9a$export$2e2bcd8739ae039 = $e1d4aa1e050b8c9a$var$useSocialProofExperiment;



var $86rMt = parcelRequire("86rMt");





var $7d67T = parcelRequire("7d67T");





var $1RvsP = parcelRequire("1RvsP");


var $l7DP7 = parcelRequire("l7DP7");


var $jI5eg = parcelRequire("jI5eg");

var $gHW9t = parcelRequire("gHW9t");













const $db812bc1dbeef64f$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $5TXU5.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $afp1H.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).connect_link_account_card),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });


var $7771ef3243025b88$exports = {};
$7771ef3243025b88$exports = new URL("general@2x.8b524499.png", import.meta.url).toString();











var $iXCQx = parcelRequire("iXCQx");




// TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
const $d2faf6f6d30dfe00$var$SocialProofMessage = ({ tier: tier, connectedPct: connectedPct, providerName: providerName, testId: testId = 'smart-block-social-proof-message' })=>{
    const message = tier === 'not-low' ? (0, $afp1H.messages).pre_auth_block_social_proof_not_low : (0, $afp1H.messages).pre_auth_block_social_proof_low;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...message,
        values: {
            percentage: connectedPct ?? 0,
            provider: providerName,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                    as: "strong",
                    weight: "bold"
                }, chunks)
        }
    }));
};
var $d2faf6f6d30dfe00$export$2e2bcd8739ae039 = $d2faf6f6d30dfe00$var$SocialProofMessage;




const $6f3b666d5dd2a24b$var$contentStyles = null;
const $6f3b666d5dd2a24b$var$contentAdditionalStyles = null;
const $6f3b666d5dd2a24b$var$newTitleBlockStyles = null;
const $6f3b666d5dd2a24b$var$intermediumGapStyles = null;
const $6f3b666d5dd2a24b$var$titleBlockStyles = null;
const $6f3b666d5dd2a24b$var$previewBlockStyle = null;
const $6f3b666d5dd2a24b$var$previewBlockStyleWithOverlap = null;
const $6f3b666d5dd2a24b$var$linkIconStyles = null;
const $6f3b666d5dd2a24b$var$containerStyles = null;
const $6f3b666d5dd2a24b$var$previewBlockImageStyle = null;
const $6f3b666d5dd2a24b$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
const $6f3b666d5dd2a24b$var$getBetterTitle = (url)=>{
    // List of regexps to extract human-readable titles from URLs
    // Each regex should have a capture group for the title at index 1
    const titleExtractors = [
        // Dropbox: https://www.dropbox.com/scl/fi/scebraopvx4bni0sechq9/Atlas23_D1_A_0014.jpg?rlkey=... -> Atlas23_D1_A_0014.jpg
        /^https:\/\/www\.dropbox\.com\/scl\/fi\/[^\/]+\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home/Teamwork%20Ecosystem?preview=xsociety00.dat -> Teamwork Ecosystem
        /^https:\/\/www\.dropbox\.com\/home\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home?preview=Insomnia-All_2019-03-14.json -> Insomnia-All_2019-03-14.json
        /^https:\/\/www\.dropbox\.com\/home\?(?:.*?&)?preview=([^&#]+)/,
        // Dropbox: https://www.dropbox.com/preview/AI%20Contest -> AI Contest
        /^https:\/\/www\.dropbox\.com\/preview\/([^&?]+)/,
        // Dropbox: https://www.dropbox.com/s/votiehk00g4opif/xsociety00.dat?dl=0 -> xsociety00.dat
        /^https:\/\/www\.dropbox\.com\/(?:s|sh|sc|t)\/[^\/]+\/([^\/\?]+)/,
        // Figma: https://www.figma.com/slides/vW47To0dYPnT7jlrJdUd7h/Universal-Create-in-TwC?node-id=... -> Universal-Create-in-TwC
        // Also supports: /file/, /design/, /board/, /proto/
        /^https:\/\/(?:[\w.-]+\.)?figma\.com\/(?:design|board|file|proto|slides)\/[0-9a-zA-Z]{22,128}\/([^\/\?]+)/,
        // OneDrive: https://1drv.ms/w/s!ABC123DEF456/Project_Plan.docx?e=abcdEF -> Project_Plan.docx
        /^https:\/\/1drv\.ms\/[a-z]+\/s![^\/]+\/([^\/\?]+)/,
        // Miro: https://miro.com/app/board/uXjVOPnT123=/my-board-name/ -> my-board-name
        /^https:\/\/miro\.com\/app\/board\/[^\/]+\/([^\/\?]+)\/?/
    ]; // Try each extractor pattern
    for (const pattern of titleExtractors){
        const match = url.match(pattern);
        if (match) {
            const extracted = decodeURIComponent(match[1]);
            if (extracted) return extracted;
        }
    }
    try {
        const { pathname: pathname, search: search } = new URL(url);
        if (pathname.length > 1) return pathname.substring(1);
        if (search) return search;
         // Fall back to the full URL when there is no useful path/search to display,
        // so the title (and the underlying link) always has accessible text.
        return url;
    } catch  {
        return url;
    }
};
const $6f3b666d5dd2a24b$var$UnauthorisedBlock = ({ actions: actions, children: children, url: url, CompetitorPrompt: CompetitorPrompt, testId: testId })=>{
    const { ui: ui, data: data } = (0, $fUfR2.useFlexibleCardContext)() ?? {
        ui: undefined,
        data: undefined
    };
    const hasActions = actions && actions.length > 0;
    const actionGroup = hasActions ? /*#__PURE__*/ $42omo.createElement((0, $7d67T.default), {
        size: (0, $5TXU5.SmartLinkSize).Large,
        items: actions
    }) : null;
    const competitorPrompt = CompetitorPrompt && data?.url ? /*#__PURE__*/ $42omo.createElement(CompetitorPrompt, {
        sourceUrl: data?.url,
        linkType: 'card'
    }) : null;
    const title = /*#__PURE__*/ $42omo.createElement((0, $gHW9t.default), {
        hideTooltip: false,
        maxLines: 1,
        theme: ui?.theme,
        text: $6f3b666d5dd2a24b$var$getBetterTitle(url),
        className: (0, $gMc0m.default)([
            "_k48p1pd9 _syaz13af"
        ])
    });
    const { position: position } = (0, $f52e364f0b2ceb52$export$45bdb4108909a713);
    let overrideUrl = data?.preview?.url ?? (0, (/*@__PURE__*/$parcel$interopDefault($7771ef3243025b88$exports)));
    return /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), {
        ...(0, $f52e364f0b2ceb52$export$45bdb4108909a713),
        testId: `${testId}-errored-view`,
        className: (0, $gMc0m.default)([
            "_7cca15wb _1f3816vg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: (0, $5TXU5.SmartLinkSize).Medium,
        className: (0, $gMc0m.default)([
            "_zulputpp"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $2R1C4.default), null, /*#__PURE__*/ $42omo.createElement((0, $jI5eg.default), {
        position: position,
        size: (0, $5TXU5.SmartLinkSize).Medium,
        isTiledIcon: true,
        className: (0, $gMc0m.default)([
            "_vsqgglyw"
        ])
    }), /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        direction: (0, $5TXU5.SmartLinkDirection).Vertical,
        width: (0, $5TXU5.SmartLinkWidth).Flexible,
        size: (0, $5TXU5.SmartLinkSize).Large,
        className: (0, $gMc0m.default)([
            "_zulpidpf"
        ])
    }, competitorPrompt ? /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $6f3b666d5dd2a24b$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, /*#__PURE__*/ $42omo.createElement((0, $1RvsP.default), {
        size: (0, $5TXU5.SmartLinkSize).Medium,
        direction: (0, $5TXU5.SmartLinkDirection).Horizontal
    }, (0, $l7DP7.renderElementItems)([
        {
            name: (0, $5TXU5.ElementName).HostName
        }
    ])))), children, actionGroup), hasActions ? /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bsb1o87 _1wpz1fhb _1dptglyw",
            "_1bsbo60d"
        ])
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            backgroundImage: `url(${overrideUrl})`
        },
        className: (0, $gMc0m.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _4t3i1osq _1bsb1o87 _1lrw1f51 _ouxl1ssb _12vemgnk"
        ])
    })) : null);
}; /**
    * This view represents a Block card that has an 'Unauthorized' status .
    * It should have a "Connect" button that will allow a user to connect their account and view the block card.
    *
    * @see SmartLinkStatus
    * @see FlexibleCardProps
    */ 
const $6f3b666d5dd2a24b$var$UnauthorisedViewFrame = ({ content: content, providerName: providerName, testId: testId, ...props })=>{
    const { onAuthorize: onAuthorize } = props;
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleAuthorize = (0, $42omo.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const actions = (0, $42omo.useMemo)(()=>onAuthorize ? [
            (0, $db812bc1dbeef64f$export$34cef2b72294bd84)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $42omo.createElement((0, $8k046.default), {
        appearance: "block",
        onAuthorize: onAuthorize,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $f52e364f0b2ceb52$export$22ebf74c8bee4708),
        ...props
    }, /*#__PURE__*/ $42omo.createElement($6f3b666d5dd2a24b$var$UnauthorisedBlock, {
        actions: actions,
        cardState: props.cardState,
        CompetitorPrompt: props.CompetitorPrompt,
        testId: testId,
        url: props.url
    }, /*#__PURE__*/ $42omo.createElement("div", {
        "data-testid": `${testId}-content`,
        className: (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo _19pku2gc",
            actions.length > 0 && "_1reo15vq _18m915vq _otyrpxbi _p12f1osq _o5721q9c _1bto1l2s"
        ])
    }, content)));
};
const $6f3b666d5dd2a24b$var$UnauthorisedViewBase = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $a1WXB.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $226XV.hasAuthScopeOverrides)(cardState.details);
    const content = (0, $42omo.useMemo)(()=>onAuthorize ? /*#__PURE__*/ $42omo.createElement((0, $86rMt.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $afp1H.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    return /*#__PURE__*/ $42omo.createElement($6f3b666d5dd2a24b$var$UnauthorisedViewFrame, {
        ...props,
        content: content,
        providerName: providerName,
        testId: testId
    });
}; /**
    * Experiment wrapper: fires social proof exposure and renders social proof UI when FG is on.
    * TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    */ 
const $6f3b666d5dd2a24b$var$UnauthorisedViewWithExperiment = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const extensionKey = props.cardState?.details?.meta?.key;
    (0, $fBMbo.di)((0, $e1d4aa1e050b8c9a$export$2e2bcd8739ae039));
    const providerName = (0, $a1WXB.extractSmartLinkProvider)(props.cardState.details)?.text;
    const { connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { isTreatment: isTreatment, tier: tier, connectedPct: connectedPct } = (0, $e1d4aa1e050b8c9a$export$2e2bcd8739ae039)(providerName ? extensionKey : undefined, connections.client.baseUrlOverride);
    const socialProofExperimentMeta = (0, $e1d4aa1e050b8c9a$export$49fab64ef7e3aab7)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: connections.client.baseUrlOverride
    });
    const analyticsContextData = {
        attributes: {
            experiment: 'social_proof_3p_unauth_block_exp',
            cohort: isTreatment ? 'treatment' : 'control',
            tier: tier,
            experimentMeta: socialProofExperimentMeta
        }
    };
    if (!isTreatment || !providerName) {
        const fallbackView = /*#__PURE__*/ $42omo.createElement($6f3b666d5dd2a24b$var$UnauthorisedViewBase, {
            ...props,
            testId: testId
        });
        return connectedPct !== undefined ? /*#__PURE__*/ $42omo.createElement((0, $bYRk6.default), {
            data: analyticsContextData
        }, fallbackView) : fallbackView;
    }
    return /*#__PURE__*/ $42omo.createElement((0, $bYRk6.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ $42omo.createElement($6f3b666d5dd2a24b$var$UnauthorisedViewFrame, {
        ...props,
        content: /*#__PURE__*/ $42omo.createElement((0, $d2faf6f6d30dfe00$export$2e2bcd8739ae039), {
            tier: tier,
            connectedPct: connectedPct,
            providerName: providerName
        }),
        providerName: providerName,
        testId: testId
    }));
};
const $6f3b666d5dd2a24b$var$UnauthorisedViewWithoutExperiment = (props)=>{
    return /*#__PURE__*/ $42omo.createElement($6f3b666d5dd2a24b$var$UnauthorisedViewBase, props);
};
const $6f3b666d5dd2a24b$var$UnauthorisedView = (0, $bedQP.componentWithFG)('social-proof-3p-unauth-block-fg', $6f3b666d5dd2a24b$var$UnauthorisedViewWithExperiment, $6f3b666d5dd2a24b$var$UnauthorisedViewWithoutExperiment);
const $6f3b666d5dd2a24b$var$_default_1 = (0, $53d96f90b9ec11b4$export$36ce1a3a446661ab)($6f3b666d5dd2a24b$var$UnauthorisedView);
var $6f3b666d5dd2a24b$export$2e2bcd8739ae039 = $6f3b666d5dd2a24b$var$_default_1;


const $238267d50ac451f9$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "smart-card-block-card"
    }), children);
const $238267d50ac451f9$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $izGro.handleClickCommon)(event, handleFrameClick),
        onAuxClick: handleFrameAuxClick,
        onContextMenu: handleFrameContextMenu,
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $00d3b0f3bfadf328$export$f93c47f1b2b3f55b)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($238267d50ac451f9$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2f9c513d2386c05$export$2e2bcd8739ae039), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            }));
        case 'resolved':
            if ((0, $d51bcf9a409e676a$export$a019611f39785186)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f3b666d5dd2a24b$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2f9c513d2386c05$export$2e2bcd8739ae039), blockCardProps);
        case 'unauthorized':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f3b666d5dd2a24b$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e0dd06a6bd5fc7bf$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $464ca6acd99b1f7c$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1KuCI.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e4bb3a6bbb490086$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};



























var $7hXqf = parcelRequire("7hXqf");




function $1915e46bfdde9181$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $a1WXB.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $7hXqf.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $a1WXB.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $a1WXB.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $1915e46bfdde9181$export$6ec4b6b24dec9156(response) {
    if ((0, $a1WXB.isEntityPresent)(response)) return (0, $a1WXB.extractEntityProvider)(response);
    return $1915e46bfdde9181$export$8dcb07487061d3c1(response?.data || (0, $4ibS1.getEmptyJsonLd)());
}



var $fHhRu = parcelRequire("fHhRu");


var $cUjGA = parcelRequire("cUjGA");

const $bb40d9d37dcb3978$export$d6cf81ca6e68bcc3 = (response, _platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $4ibS1.getEmptyJsonLd)();
    return {
        link: (0, $a1WXB.extractSmartLinkUrl)(response) || '',
        title: (0, $a1WXB.extractSmartLinkTitle)(response),
        context: (0, $1915e46bfdde9181$export$6ec4b6b24dec9156)(response),
        preview: (0, $a1WXB.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $cUjGA.extractIsTrusted)(meta),
        isSupportTheming: (0, $fHhRu.extractIsSupportTheming)(meta),
        type: (0, $a1WXB.extractType)(jsonLd)
    };
};















var $lebfc = parcelRequire("lebfc");





var $8PFSM = parcelRequire("8PFSM");


var $gV3jM = parcelRequire("gV3jM");


var $iZCav = parcelRequire("iZCav");


var $5NrIb = parcelRequire("5NrIb");


var $7G33r = parcelRequire("7G33r");








var $8sXiv = parcelRequire("8sXiv");

const $62afcba05a01b8b8$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};






var $chO1Z = parcelRequire("chO1Z");





var $6iY4P = parcelRequire("6iY4P");


var $66dpz = parcelRequire("66dpz");











const $46b42d24f0b615cc$var$getBlogIconWrapped = ()=>(parcelRequire("7r4Rz")).default;

const $46b42d24f0b615cc$var$getDocumentIcon = ()=>(parcelRequire("9SMct")).default;

const $46b42d24f0b615cc$var$getFileIcon = ()=>(parcelRequire("9JsQ8")).default;

const $46b42d24f0b615cc$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("GFtWS")).default;

const $46b42d24f0b615cc$var$getPresentationIcon = ()=>(parcelRequire("1w5AW")).default;

const $46b42d24f0b615cc$var$getSpreadsheetIcon = ()=>(parcelRequire("h45kr")).default;
const $46b42d24f0b615cc$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $46b42d24f0b615cc$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $46b42d24f0b615cc$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $7hXqf.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $46b42d24f0b615cc$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $ivUmx.getIconForFileType)(opts.fileFormat, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined);
};
const $46b42d24f0b615cc$var$documentLabel = (opts, label)=>{
    // NAVX-4354 can be inlined during cleanup.
    if (!opts.showIconLabel) return '';
    return (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};
const $46b42d24f0b615cc$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                if ((0, $dh538.fg)('platform_sl_icons_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
                    label: $46b42d24f0b615cc$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
                const BlogIconWrapped = $46b42d24f0b615cc$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(BlogIconWrapped, {
                    label: $46b42d24f0b615cc$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $46b42d24f0b615cc$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $46b42d24f0b615cc$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                    label: $46b42d24f0b615cc$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $46b42d24f0b615cc$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PresentationIcon, {
                    label: $46b42d24f0b615cc$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $46b42d24f0b615cc$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SpreadsheetIcon, {
                    label: $46b42d24f0b615cc$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                color: "currentColor",
                label: $46b42d24f0b615cc$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $46b42d24f0b615cc$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DocumentIcon, {
                    label: $46b42d24f0b615cc$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $46b42d24f0b615cc$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $a1WXB.isConfluenceGenerator)(opts.provider.id)) {
        if ((0, $dh538.fg)('platform_sl_icons_refactor')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66dpz.default), {
            label: $46b42d24f0b615cc$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
        const LiveDocumentIconWrapped = $46b42d24f0b615cc$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LiveDocumentIconWrapped, {
            label: $46b42d24f0b615cc$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    } else {
        const FileIcon = $46b42d24f0b615cc$var$getFileIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FileIcon, {
            label: $46b42d24f0b615cc$var$documentLabel(opts, 'file'),
            testId: "file-icon"
        });
    }
};






var $l5jcq = parcelRequire("l5jcq");


var $1WiZb = parcelRequire("1WiZb");


var $kWiYc = parcelRequire("kWiYc");


var $cKqka = parcelRequire("cKqka");


var $7Jxvl = parcelRequire("7Jxvl");


var $9J3bP = parcelRequire("9J3bP");


var $4KIbP = parcelRequire("4KIbP");





var $8d3zB = parcelRequire("8d3zB");





var $15w8R = parcelRequire("15w8R");

const $e880c03763857185$var$TaskIcon = (0, $7G33r.default);
const $e880c03763857185$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e880c03763857185$var$TaskIcon, {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $15w8R.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $15w8R.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $15w8R.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KIbP.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $15w8R.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J3bP.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $15w8R.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5jcq.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $15w8R.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kWiYc.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $15w8R.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cKqka.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $15w8R.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $15w8R.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1WiZb.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $15w8R.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Jxvl.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $15w8R.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};






var $uAXxz = parcelRequire("uAXxz");

const $0a72c1de75dc71b8$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $a1WXB.extractTitle)(jsonLd)
        },
        provider: (0, $a1WXB.extractProvider)(jsonLd),
        fileFormat: (0, $62afcba05a01b8b8$export$f2d65f02f6888b60)(jsonLd),
        taskType: (0, $8sXiv.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $a1WXB.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $uAXxz.extractorPriorityMap)[b] - (0, $uAXxz.extractorPriorityMap)[a])[0];
        return $0a72c1de75dc71b8$var$extractIconByType(highestPriorityType, opts);
    } else return $0a72c1de75dc71b8$var$extractIconByType(type, opts);
};
function $0a72c1de75dc71b8$var$typeToIcon(type, opts) {
    const getLabel = (title)=>(0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iZCav.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lebfc))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5NrIb.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8PFSM.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gV3jM.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $e880c03763857185$export$321256ed044e3100)(opts);
        default:
            return undefined;
    }
}
function $0a72c1de75dc71b8$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $0a72c1de75dc71b8$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $ivUmx.getIconForFileType)(opts.fileFormat, (0, $dh538.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $7hXqf.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $0a72c1de75dc71b8$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $46b42d24f0b615cc$export$25c24c7f577936d3)(type, opts);
        default:
            return $0a72c1de75dc71b8$var$standardisedExtractIcon(type, opts);
    }
};



var $dKrmg = parcelRequire("dKrmg");




const $547f36a8a360e3f7$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $uAXxz.extractorPriorityMap)[b] - (0, $uAXxz.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return "var(--ds-text-danger, #AE2E24)";
            default:
                return undefined;
        }
    }
};


const $9ae2edd7013570b0$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $9ae2edd7013570b0$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $9ae2edd7013570b0$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};





const $4c72e12ee124eec0$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $a1WXB.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $15w8R.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $15w8R.JIRA_GENERATOR_ID)) return (0, $0a72c1de75dc71b8$export$64bdf1f5e49e8626)(jsonLd, 'type', showIconLabel);
    }
    return (0, $0a72c1de75dc71b8$export$64bdf1f5e49e8626)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $4c72e12ee124eec0$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $a1WXB.isEntityPresent)(response)) {
        if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $a1WXB.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $a1WXB.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $4c72e12ee124eec0$var$extractInlineIcon(response?.data || (0, $4ibS1.getEmptyJsonLd)(), showLabel);
};
const $4c72e12ee124eec0$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $4ibS1.getEmptyJsonLd)();
    return {
        link: (0, $a1WXB.extractSmartLinkUrl)(response),
        title: (0, $a1WXB.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: $4c72e12ee124eec0$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $dKrmg.extractLozenge)(jsonLd),
        titleTextColor: (0, $547f36a8a360e3f7$export$a2afc198e9dada1)(jsonLd),
        titlePrefix: (0, $9ae2edd7013570b0$export$58d9bc37318dfb32)(jsonLd, renderers, 'inline'),
        type: (0, $a1WXB.extractType)(jsonLd)
    };
};












var $lwDWG = parcelRequire("lwDWG");

/* ErroredView.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $ccHMk = parcelRequire("ccHMk");


var $a3fRD = parcelRequire("a3fRD");




var $u9agA = parcelRequire("u9agA");




/* ErrorFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $d22f66dd7c7efe76$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d22f66dd7c7efe76$export$f862a410248f4f00, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d22f66dd7c7efe76$export$7b360cd785b6c366, props);
const $d22f66dd7c7efe76$var$sharedBaseFrameStyles = null;
const $d22f66dd7c7efe76$var$sharedFrameStyles = null;
const $d22f66dd7c7efe76$var$expandedFrameHoverStyles = null;
const $d22f66dd7c7efe76$var$expandedFrameFluidHeightTrueStyles = null;
const $d22f66dd7c7efe76$var$expandedFrameFluidHeightFalseStyles = null;
const $d22f66dd7c7efe76$var$expandedFrameSelectedStyles = null;
const $d22f66dd7c7efe76$var$expandedFrameNotSelectedStyles = null;
const $d22f66dd7c7efe76$var$expandedFrameStyles = null;
const $d22f66dd7c7efe76$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr31dpa _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6dq98m _1dqonqa1 _189e1dm9" : "_2rkolb4i _1h6d1j28 _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qst7xp",
            className
        ]),
        "data-trello-do-not-use-override": testId
    }, children);
};
const $d22f66dd7c7efe76$var$compactFrameHoverStyles = null;
const $d22f66dd7c7efe76$var$compactFrameInheritDimensionsTrueStyles = null;
const $d22f66dd7c7efe76$var$compactFrameInheritDimensionsFalseStyles = null;
const $d22f66dd7c7efe76$var$compactFrameAlignStyles = null;
const $d22f66dd7c7efe76$var$compactFrameStyles = null;
const $d22f66dd7c7efe76$var$compactFrameNotSelectedStyles = null;
const $d22f66dd7c7efe76$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3plhp",
            isSelected && "_2rkofajl _1h6dq98m _1dqonqa1 _189e1dm9",
            !isSelected && "_2rkolb4i",
            "_1bah1h6o _4cvr1h6o _bfhki8nm",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ])
    }, children);
};


const $b65311d39834ef44$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $b65311d39834ef44$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ $42omo.createElement((0, $d22f66dd7c7efe76$export$b89a827e9254211a), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error-icon"
    }), /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: $b65311d39834ef44$var$styles.boxStyles
    }, /*#__PURE__*/ $42omo.createElement((0, $u9agA.default), null, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).could_not_load_link))), /*#__PURE__*/ $42omo.createElement((0, $ccHMk.default), {
        testId: "err-view-retry",
        spacing: "compact",
        onClick: onRetry
    }, /*#__PURE__*/ $42omo.createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).try_again)));















/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cO1el = parcelRequire("cO1el");


var $1bY7o = parcelRequire("1bY7o");





var $71ssd = parcelRequire("71ssd");

/* ImageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $6Eovk = parcelRequire("6Eovk");


var $kVnOi = parcelRequire("kVnOi");

const $bbe3e117792c8ab9$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $bbe3e117792c8ab9$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false); // If url changes, reset state
    (0, $42omo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $42omo.useCallback)(()=>{
        setHasImageErrored(true);
    }, []); // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if (hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kVnOi.Image // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: (0, $gMc0m.default)([
            appearance === 'round' && $bbe3e117792c8ab9$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton ? {
            onError: handleError
        } : undefined
    });
    if (hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Eovk.default), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};


const $ed98787a881b8249$var$containerStyles = null;
const $ed98787a881b8249$var$contentStyles = null;
const $ed98787a881b8249$var$imageStyles = null;
const $ed98787a881b8249$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $42omo.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bbe3e117792c8ab9$export$4a122bafaa48b23d), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "icon",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $42omo.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $gMc0m.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": imageTestId,
            className: (0, $gMc0m.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        }, imageUrlOrElement);
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71ssd.ExpandedFrame // Scroll bar must be shown for unresolved views to display the connect account button
    ), {
        allowScrollBar: true,
        setOverflow: true,
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": `${testId}-unresolved-container`,
        className: (0, $gMc0m.default)([
            "_1e0c11p5 _4t3i1kw7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
        ])
    }, image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        testId: `${testId}-unresolved-title`
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        align: "center",
        testId: `${testId}-unresolved-description`
    }, description), button)));
};
var $ed98787a881b8249$export$2e2bcd8739ae039 = $ed98787a881b8249$var$UnresolvedView;





const $09298d55c4b62d9a$export$f51768a4e7ff128 = ()=>{
    const gradientId = (0, $42omo.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: gradientId,
        gradientUnits: "userSpaceOnUse",
        x1: "49.4199",
        x2: "122.662",
        y1: "59.7673",
        y2: "59.7673"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0",
        stopColor: "#0065ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: ".2188",
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: ".5999",
        stopColor: "#2780ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
        fill: `url(#${gradientId})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
        fill: "#ff7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
        fill: "#344563"
    }));
};


const $786b5ddfe6ac7939$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $42omo.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, hostname)
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
   * if there is a request access context, but no action to perform, do not show any button.
   * By default, a "Try another account" button shows, but with request access context, we don't
   * want to encourage users to try another account, if their request is already pending, etc.
   */ const button = (0, $42omo.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).try_another_account, callToActionMessageKey),
            values: values
        }));
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed98787a881b8249$export$2e2bcd8739ae039), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $09298d55c4b62d9a$export$f51768a4e7ff128), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $786b5ddfe6ac7939$export$2e2bcd8739ae039 = $786b5ddfe6ac7939$var$ForbiddenView;



















const $665f1002504426e5$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "1316.98",
        y1: "230.66",
        x2: "1396.36",
        y2: "230.66",
        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0",
        stopColor: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#6c798f"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "170.3",
        y1: "897.49",
        x2: "365.15",
        y2: "897.49",
        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0",
        stopColor: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.69",
        stopColor: "#fff",
        stopOpacity: "0.1"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("title", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        defaultMessage: "Search error",
        id: "smart-card.not-found-svg.title"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        id: "Objects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#cfd4db",
        d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "_Path_",
        "data-name": "<Path>",
        fill: "url(#linear-gradient)",
        d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#091e42",
        opacity: 0.1,
        d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#344563",
        d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "_Clipping_Path_",
        "data-name": "<Clipping Path>",
        fill: "#deebff",
        d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        id: "_Path_2",
        "data-name": "<Path>",
        fill: "#b2d4ff",
        d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#cce0ff",
        d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "url(#linear-gradient-2)",
        d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("polygon", {
        id: "_Path_3",
        "data-name": "<Path>",
        fill: "#5e6c84",
        points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#ffc400",
        d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "#ffc400",
        d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#344563",
        d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
    }))));


const $4f300938e91472ad$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $42omo.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed98787a881b8249$export$2e2bcd8739ae039), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $665f1002504426e5$export$80542c1714a314c8), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $70f63e68a5826333$export$d14c2a6dee946f52)((0, $afp1H.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $4f300938e91472ad$export$2e2bcd8739ae039 = $4f300938e91472ad$var$NotFoundView;












var $cOrQJ = parcelRequire("cOrQJ");







/* Frame.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $hTKp4 = parcelRequire("hTKp4");








var $iWvOt = parcelRequire("iWvOt");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $8174cb4ba3d12295$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $8174cb4ba3d12295$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $42omo.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $42omo.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $42omo.useEffect)(()=>{
        if (dwell.time > 0 && $8174cb4ba3d12295$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $42omo.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        // Require: iframe loaded, mouse over, and >75% visible.
        // Note: isWindowFocused is intentionally not required - it's unreliable and
        // prevents tracking. The mouse over check is sufficient to indicate user engagement.
        const shouldTrack = isIframeLoaded && isMouseOver && iframePercentVisible > 0.75;
        if (shouldTrack) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        } else if (dwellTimeoutId.current) {
            clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = undefined;
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};


function $99890bfb177b42df$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $99890bfb177b42df$var$iframeStyles = null;
const $99890bfb177b42df$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isMouseOver: isMouseOverProp, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $fBMbo.di)((0, $iWvOt.IFrame));
    const doc = (0, $hTKp4.getDocument)();
    const [isIframeLoaded, setIframeLoaded] = (0, $42omo.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $42omo.useState)(false); // Accessing the document here for SSR where document.hasFocus may be absent breaks SSR
    // when we're trying to load things like Loom frames in SSR
    // We _could_ either throw a guard in here (i.e check for the existence of document)
    // _or_
    // we can default to false, and set this state once the frame ref is available in a useEffect (safer IMO)
    // which already seems to be existing behavior in a useEffect below.
    const [isWindowFocused, setWindowFocused] = (0, $42omo.useState)(// The below will be removed as part of FG cleanup
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (0, $dh538.fg)('jpx-1074-smart-links-iframe') ? doc?.hasFocus() ?? false : document.hasFocus()); // Use prop if provided (from wrapper), otherwise use local state (for backward compatibility)
    const effectiveMouseOver = isMouseOverProp !== undefined ? isMouseOverProp : isMouseOver;
    const ref = (0, $42omo.useRef)();
    const mergedRef = $99890bfb177b42df$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $42omo.useState)(0); /**
                                                            * These are the 'percent visible' thresholds at which the intersectionObserver will
                                                            * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
                                                            * vice versa. It's in a state object so that its static for the useEffect
                                                            */ 
    const [threshold] = (0, $42omo.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // Initialize with current focus state
        // The below will be removed as part of FG cleanup
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        setWindowFocused((0, $dh538.fg)('jpx-1074-smart-links-iframe') ? doc?.hasFocus() ?? false : document.hasFocus());
        const onBlur = ()=>{
            setWindowFocused(false);
            if ((0, $dh538.fg)('jpx-1074-smart-links-iframe')) {
                if (doc?.activeElement === ref.current) onIframeFocus && onIframeFocus();
            } else // The below will be removed as part of FG cleanup
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus,
        doc
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8174cb4ba3d12295$export$e3cb965901aecabd), {
        isIframeLoaded: isIframeLoaded,
        isMouseOver: effectiveMouseOver,
        isWindowFocused: isWindowFocused,
        iframePercentVisible: percentVisible,
        onIframeDwell: onIframeDwell
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iWvOt.IFrame), {
        childRef: mergedRef,
        src: url,
        "data-testid": `${testId}-frame`,
        "data-test-iframe-loaded": isIframeLoaded,
        onMouseEnter: ()=>{
            onIframeMouseEnter?.(); // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(true);
        },
        onMouseLeave: ()=>{
            onIframeMouseLeave?.(); // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(false);
        },
        allowFullScreen: true,
        scrolling: "yes",
        allow: "autoplay; encrypted-media; clipboard-write",
        onLoad: ()=>{
            setIframeLoaded(true);
        },
        sandbox: (0, $ivUmx.getIframeSandboxAttribute)(isTrusted),
        title: title,
        extensionKey: extensionKey,
        className: (0, $gMc0m.default)([
            "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
        ])
    }));
});







var $7DSoa = parcelRequire("7DSoa");

const $12f427ae257095f0$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $7DSoa.default)();
    (0, $42omo.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve(url, true);
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};


const $1819a7380571eb1c$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ link: link, context: context, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const iconLabel = context?.iconLabel;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: "icon",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bbe3e117792c8ab9$export$4a122bafaa48b23d), {
            src: src,
            ...(0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                alt: iconLabel
            } : undefined,
            default: linkGlyph,
            appearance: (0, $ivUmx.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton,
        iconLabel
    ]);
    (0, $12f427ae257095f0$export$50ac35a9a8f2ebaa)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $cOrQJ.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $ivUmx.getPreviewUrlWithTheme)(previewUrl, themeState);
    const [isMouseOver, setMouseOver] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71ssd.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        onContentMouseEnter: ()=>{
            setMouseOver(true);
            onIframeMouseEnter?.();
        },
        onContentMouseLeave: ()=>{
            setMouseOver(false);
            onIframeMouseLeave?.();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $99890bfb177b42df$export$b89a827e9254211a), {
        url: previewUrl,
        isTrusted: isTrusted,
        testId: testId,
        ref: embedIframeRef,
        onIframeDwell: onIframeDwell,
        onIframeFocus: onIframeFocus,
        onIframeMouseEnter: onIframeMouseEnter,
        onIframeMouseLeave: onIframeMouseLeave,
        isMouseOver: isMouseOver,
        title: text,
        extensionKey: extensionKey
    }));
});
























const $4eb7014df67e9d3c$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_1375_267)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        transform: "translate(0.870117 0.509766)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
        stroke: "url(#paint0_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
        fill: "#403294"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.25",
        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
        fill: "url(#paint1_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.25",
        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
        fill: "url(#paint2_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
        stroke: "url(#paint3_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        opacity: "0.38",
        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
        fill: "url(#paint4_radial_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
        fill: "url(#paint5_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
        fill: "url(#paint6_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
        fill: "url(#paint7_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
        fill: "url(#paint8_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
        fill: "url(#paint9_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
        fill: "url(#paint10_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
        fill: "url(#paint11_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
        fill: "url(#paint12_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
        fill: "url(#paint13_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
        fill: "url(#paint14_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
        fill: "url(#paint15_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
        fill: "url(#paint16_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
        fill: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
        fill: "url(#paint17_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
        fill: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
        fill: "url(#paint18_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint0_linear_1375_267",
        x1: "141.994",
        y1: "181.192",
        x2: "0.870117",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#C1C7D0",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint1_linear_1375_267",
        x1: "208.292",
        y1: "264.428",
        x2: "0.870117",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint2_linear_1375_267",
        x1: "357.327",
        y1: "264.428",
        x2: "564.748",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint3_linear_1375_267",
        x1: "423.624",
        y1: "181.192",
        x2: "564.748",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.1724",
        stopColor: "#076AFF",
        stopOpacity: "0.8007"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.4145",
        stopColor: "#1976FF",
        stopOpacity: "0.5208"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.6966",
        stopColor: "#378BFF",
        stopOpacity: "0.1947"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8651",
        stopColor: "#4C9AFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("radialGradient", {
        id: "paint4_radial_1375_267",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(285 99.0229) scale(96.5182)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.1584",
        stopColor: "#FFE587",
        stopOpacity: "0.8416"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.3589",
        stopColor: "#FFDA57",
        stopOpacity: "0.6411"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.5498",
        stopColor: "#FFD031",
        stopOpacity: "0.4502"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.7256",
        stopColor: "#FFC916",
        stopOpacity: "0.2744"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8811",
        stopColor: "#FFC506",
        stopOpacity: "0.1189"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint5_linear_1375_267",
        x1: "346.074",
        y1: "98.8386",
        x2: "423.624",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint6_linear_1375_267",
        x1: "237.087",
        y1: "120.044",
        x2: "276.412",
        y2: "120.044",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint7_linear_1375_267",
        x1: "237.087",
        y1: "75.0106",
        x2: "276.412",
        y2: "75.0106",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint8_linear_1375_267",
        x1: "335.969",
        y1: "146.593",
        x2: "335.969",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint9_linear_1375_267",
        x1: "219.544",
        y1: "98.8386",
        x2: "141.994",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint10_linear_1375_267",
        x1: "229.65",
        y1: "146.593",
        x2: "229.65",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#F4F5F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint11_linear_1375_267",
        x1: "402.858",
        y1: "216.64",
        x2: "421.684",
        y2: "223.492",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8134",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.8713",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint12_linear_1375_267",
        x1: "376.968",
        y1: "157.139",
        x2: "433.936",
        y2: "157.139",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint13_linear_1375_267",
        x1: "289.638",
        y1: "45.0027",
        x2: "289.638",
        y2: "0.510323",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint14_linear_1375_267",
        x1: "262.238",
        y1: "36.2259",
        x2: "272.592",
        y2: "36.2259",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint15_linear_1375_267",
        x1: "259.6",
        y1: "180.859",
        x2: "259.6",
        y2: "141.017",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint16_linear_1375_267",
        x1: "284.971",
        y1: "171.613",
        x2: "284.971",
        y2: "149.45",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint17_linear_1375_267",
        x1: "157.982",
        y1: "221.995",
        x2: "188.627",
        y2: "221.995",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "0.3435",
        stopColor: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#998DD9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        id: "paint18_linear_1375_267",
        x1: "163.185",
        y1: "155.517",
        x2: "213.758",
        y2: "155.517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        offset: "1",
        stopColor: "#8777D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_1375_267"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        fill: "white",
        transform: "translate(0.870117 0.509766)"
    }))));


const $ddb0fccc1165c8d2$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $42omo.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $42omo.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...(0, $afp1H.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $86rMt.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                    ...(0, $afp1H.messages).connect_unauthorised_account_action,
                    values: values
                }))
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $afp1H.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $afp1H.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).unauthorised_account_name_no_provider),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).unauthorised_account_description_no_provider)
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ed98787a881b8249$export$2e2bcd8739ae039), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4eb7014df67e9d3c$export$6526edaac83a8c90), null),
        testId: testId,
        text: context?.text
    });
};
var $ddb0fccc1165c8d2$export$2e2bcd8739ae039 = $ddb0fccc1165c8d2$var$UnauthorizedView;


const $9898df38e732dedc$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "smart-card-embed-card"
    }), children);
const $9898df38e732dedc$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $226XV.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $226XV.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $00d3b0f3bfadf328$export$f93c47f1b2b3f55b)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9898df38e732dedc$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2f9c513d2386c05$export$2e2bcd8739ae039), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            }));
        case 'resolved':
            const resolvedViewProps = (0, $bb40d9d37dcb3978$export$d6cf81ca6e68bcc3)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio,
                extensionKey: details?.meta?.key
            });
            if ((0, $d51bcf9a409e676a$export$a019611f39785186)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $bb40d9d37dcb3978$export$d6cf81ca6e68bcc3)(details, platform);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ddb0fccc1165c8d2$export$2e2bcd8739ae039), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1819a7380571eb1c$export$30f3c6c32b384a8b), {
                ...resolvedViewProps,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $4c72e12ee124eec0$export$68e1703c529dc7e0)(details);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lwDWG.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b2f9c513d2386c05$export$2e2bcd8739ae039), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                    // Other states (e.g. "resolving") could be added later for completeness.
                    onAuxClick: handleFrameAuxClick,
                    onContextMenu: handleFrameContextMenu,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $bb40d9d37dcb3978$export$d6cf81ca6e68bcc3)(details, platform);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ddb0fccc1165c8d2$export$2e2bcd8739ae039), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $bb40d9d37dcb3978$export$d6cf81ca6e68bcc3)(details, platform);
            const cardMetadata = details?.meta ?? (0, $4ibS1.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1819a7380571eb1c$export$30f3c6c32b384a8b), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $7kN5H.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $786b5ddfe6ac7939$export$2e2bcd8739ae039), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $bb40d9d37dcb3978$export$d6cf81ca6e68bcc3)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $7kN5H.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4f300938e91472ad$export$2e2bcd8739ae039), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b65311d39834ef44$export$6819d845957344e), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});


































var $k6YoH = parcelRequire("k6YoH");


var $0JrgF = parcelRequire("0JrgF");





var $ftXku = parcelRequire("ftXku");


var $51BZB = parcelRequire("51BZB");

const $4c6ebac56df1f90a$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fwDOR.default), {
        name: "smart-card-inline-card"
    }), children);
const $4c6ebac56df1f90a$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $226XV.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $5TXU5.SmartLinkStatus).Resolved ? (0, $4c72e12ee124eec0$export$68e1703c529dc7e0)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $42omo.useEffect)(()=>{
        switch(status){
            case (0, $5TXU5.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title,
                    extensionKey: details?.meta?.key
                });
                break;
            case (0, $5TXU5.SmartLinkStatus).Errored:
            case (0, $5TXU5.SmartLinkStatus).Fallback:
            case (0, $5TXU5.SmartLinkStatus).Forbidden:
            case (0, $5TXU5.SmartLinkStatus).NotFound:
            case (0, $5TXU5.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details?.meta?.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c6ebac56df1f90a$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ftXku.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            }));
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lwDWG.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $a1WXB.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $51BZB.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $a1WXB.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $4ibS1.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $7kN5H.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0JrgF.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $a1WXB.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k6YoH.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1KuCI.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline,
                viewType: "errored"
            });
    }
};



var $dLAsE = parcelRequire("dLAsE");





var $1wGp6 = parcelRequire("1wGp6");


var $7hy9e = parcelRequire("7hy9e");


var $6tOCz = parcelRequire("6tOCz");

const $8bc1f87259cc8293$var$withCardIntersectionObserver = (Component)=>(props)=>{
        // TODO: NAVX-4682: Add feature parity to LazyIntersectionObserverCard for no lazy loading
        const { appearance: appearance, children: children, id: id, onError: onErrorCallback, ui: ui, url: url = '' } = props;
        const { onIntersecting: onIntersecting, onStatusSettled: onStatusSettled } = (0, $7hy9e.useSmartLinkSeenEvent)({
            appearance: appearance,
            children: children,
            id: id,
            ui: ui,
            url: url
        });
        const onError = (0, $42omo.useCallback)((data)=>{
            if (data?.status) onStatusSettled(data.status);
            onErrorCallback?.(data);
        }, [
            onStatusSettled,
            onErrorCallback
        ]);
        const ref = (0, $1wGp6.default)({
            onIntersecting: onIntersecting
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6tOCz.default), {
            appearance: props.appearance,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            onError: onError
        }));
    };
var $8bc1f87259cc8293$export$2e2bcd8739ae039 = $8bc1f87259cc8293$var$withCardIntersectionObserver;












const $8f8e64563c18e0a9$var$useExperimentMetaEventAttributes = ({ appearance: appearance, state: state })=>{
    const { connections: { client: { baseUrlOverride: baseUriWithNoTrailingSlash } } } = (0, $eIleF.useSmartLinkContext)();
    const { details: details, status: status } = state;
    const extensionKey = (0, $226XV.getExtensionKey)(details);
    if (!(0, $dh538.fg)('social-proof-3p-unauth-block-fg') && !(0, $dh538.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch')) return undefined;
    const blockSocialProofExperimentMeta = appearance === 'block' && status === 'unauthorized' && (0, $dh538.fg)('social-proof-3p-unauth-block-fg') ? (0, $e1d4aa1e050b8c9a$export$49fab64ef7e3aab7)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const inlineSocialProofExperimentMeta = appearance === 'inline' && status === 'unauthorized' && (0, $dh538.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch') ? (0, $e1d4aa1e050b8c9a$export$e53e13aaa7d7b805)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const experimentMeta = {
        ...blockSocialProofExperimentMeta,
        ...inlineSocialProofExperimentMeta
    };
    if (Object.keys(experimentMeta).length > 0) return experimentMeta;
};
var $8f8e64563c18e0a9$export$2e2bcd8739ae039 = $8f8e64563c18e0a9$var$useExperimentMetaEventAttributes;


const $a4759445b1a20954$var$thirdPartyARIPrefix = 'ari:third-party';
const $a4759445b1a20954$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT = 'linking_platform_track_non_primary_3p_clicks';
function $a4759445b1a20954$var$Component({ id: id, url: url, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    let isFlexibleUi = (0, $42omo.useMemo)(()=>(0, $9E8aG.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $76aaca0831a6f2dc$export$9f4e486b1dc3e700)(id, url);
    const ari = (0, $226XV.getObjectAri)(state.details);
    const name = (0, $226XV.getObjectName)(state.details);
    const definitionId = (0, $226XV.getDefinitionId)(state.details);
    const extensionKey = (0, $226XV.getExtensionKey)(state.details);
    const resourceType = (0, $226XV.getResourceType)(state.details);
    const services = (0, $226XV.getServices)(state.details);
    const thirdPartyARI = (0, $226XV.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $226XV.getFirstPartyIdentifier)();
    const actionOptions = (0, $8b4d30aa6042b620$export$2ae4cf79c720146a)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    const { isEnabled: rovoActionsCtaShown } = (0, $8qPK2.default)(url, showHoverPreview, actionOptions);
    const fire3PClickEvent = (0, $dh538.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dLAsE.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = thirdPartyARI && thirdPartyARI.startsWith($a4759445b1a20954$var$thirdPartyARIPrefix) && (0, $226XV.getClickUrl)(url, state.details) === url && fire3PClickEvent && (0, $dh538.fg)('platform_smartlink_3pclick_analytics');
    // Setup UI handlers.
    const handleClickWrapper = (0, $42omo.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $ivUmx.isSpecialKey)(event) || (0, $ivUmx.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $5TXU5.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (shouldFire3PClickEvent) // For questions or concerns about this event,
        // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
        fire3PClickEvent?.();
        const isDisablePreviewPanel = disablePreviewPanel && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        // If preview panel is available and the user clicked on the link,
        // delegate the click to the preview panel handler
        if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
            ari: ari
        }) && !isDisablePreviewPanel) {
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $226XV.getObjectIconUrl)(state.details),
                panelData: {
                    embedUrl: (0, $1oCLl.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $a1WXB.extractSmartLinkEmbed)(state.details)?.src : undefined
                }
            });
            (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        } else if (!onClick && !isFlexibleUi) {
            const clickUrl = (0, $226XV.getClickUrl)(url, state.details);
            // Ctrl+left click on mac typically doesn't trigger onClick
            // The event could have potentially had `e.preventDefault()` called on it by now
            // event by smart card internally
            // If it has been called then only then can `isSpecialEvent` be true.
            const target = (0, $ivUmx.isSpecialEvent)(event) ? '_blank' : '_self';
            window.open(clickUrl, target);
            (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            });
        } else {
            if (onClick) onClick(event);
            (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        shouldFire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        disablePreviewPanel
    ]);
    // Exposure fires once per eligible mount; click-time reads use no-exposure variant.
    (0, $42omo.useEffect)(()=>{
        if (shouldFire3PClickEvent) (0, $1oCLl.expValEquals)($a4759445b1a20954$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true);
    }, [
        shouldFire3PClickEvent
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const handleFrameAuxClick = (0, $42omo.useCallback)((event)=>{
        // isAuxClick filters Windows right-clicks (button === 2) that also fire onAuxClick.
        if ((0, $k3uJF.isAuxClick)(event) && shouldFire3PClickEvent && (0, $dZ8uq.expValEqualsNoExposure)($a4759445b1a20954$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true)) fire3PClickEvent?.({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const handleFrameContextMenu = (0, $42omo.useCallback)((_event)=>{
        if (shouldFire3PClickEvent && (0, $dZ8uq.expValEqualsNoExposure)($a4759445b1a20954$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true)) fire3PClickEvent?.({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const handleAuthorize = (0, $42omo.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $42omo.useCallback)(()=>{
        actions.reload();
    }, [
        actions
    ]);
    const handleInvoke = (0, $42omo.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    const experimentMetaEventAttributes = (0, $8f8e64563c18e0a9$export$2e2bcd8739ae039)({
        appearance: appearance,
        state: state
    });
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $42omo.useEffect)(()=>{
        $l6tPN.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $l6tPN.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $l6tPN.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError' && state.error?.name !== 'InvalidUrlError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $42omo.useEffect)(()=>{
        if ((0, $226XV.isFinalState)(state.status)) {
            (0, $bIll3.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $bIll3.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance,
                ...appearance === 'inline' && {
                    rovoActionsCtaShown: rovoActionsCtaShown
                },
                ...experimentMetaEventAttributes && {
                    experimentMeta: experimentMetaEventAttributes
                }
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        rovoActionsCtaShown,
        state.status,
        experimentMetaEventAttributes
    ]);
    const onIframeDwell = (0, $42omo.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'focus'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseEnter = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseenter'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseLeave = (0, $42omo.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseleave'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8k046.default), {
            id: id,
            cardState: cardState,
            placeholderData: placeholderData,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            onAuxClick: handleFrameAuxClick,
            onContextMenu: handleFrameContextMenu,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            testId: testId,
            onResolve: onResolve,
            onError: onError
        }, children);
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4c6ebac56df1f90a$export$aff6291803939b05), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $238267d50ac451f9$export$d18ccd25c0d2c6b0), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9898df38e732dedc$export$6789d7ecdc77631b), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $a4759445b1a20954$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $9E8aG.isFlexibleUiCard)(props.children, props?.ui) ? (0, $5TXU5.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3eMTN.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
        url: props.url,
        id: props.id,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a4759445b1a20954$var$Component, props)));
};
const $a4759445b1a20954$export$d4ee8167ac732647 = (0, $8bc1f87259cc8293$export$2e2bcd8739ae039)($a4759445b1a20954$export$7598f5d7c597dd32);
module.exports["CardWithUrlContent"] = $a4759445b1a20954$export$7598f5d7c597dd32;
module.exports["CardWithUrl"] = $a4759445b1a20954$export$d4ee8167ac732647;

});

parcelRegister("71ssd", function(module, exports) {
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3gadb = parcelRequire("3gadb");


var $4gM1A = parcelRequire("4gM1A");


var $izGro = parcelRequire("izGro");


var $kVnOi = parcelRequire("kVnOi");

const $255a0354b87c3a2a$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk1j28 _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u1yw3",
    linkWrapperBorderAndBackground: "_1tqzia51 _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvia51 _4tpuhp5a _x148kb7n",
    header: "_11c81qyo _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c81qyo _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik1r31 _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c81qyo _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19itdlqj _2rkoy00x _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1tt7",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};
const $255a0354b87c3a2a$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt, onContentMouseEnter: onContentMouseEnter, onContentMouseLeave: onContentMouseLeave })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $izGro.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $4gM1A.useMouseDownEvent)();
    const CompetitorPromptComponent = CompetitorPrompt && href ? /*#__PURE__*/ $42omo.createElement(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $255a0354b87c3a2a$var$styles.header,
                "embed-header"
            ])
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $255a0354b87c3a2a$var$styles.leftSection
            ])
        }, /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $255a0354b87c3a2a$var$styles.headerIcon
            ])
        }, icon), /*#__PURE__*/ $42omo.createElement("div", {
            className: (0, $gMc0m.default)([
                $255a0354b87c3a2a$var$styles.tooltipWrapper
            ])
        }, !isPlaceholder && /*#__PURE__*/ $42omo.createElement((0, $3gadb.default), {
            content: text,
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ $42omo.createElement("a", {
            href: href,
            onClick: handleClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: handleMouseDown,
            className: (0, $gMc0m.default)([
                $255a0354b87c3a2a$var$styles.headerAnchor
            ])
        }, text)))), CompetitorPromptComponent);
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ $42omo.createElement("div", {
            "data-testid": "embed-content-wrapper",
            // See: HOT-107830
            contentEditable: false,
            onMouseEnter: onContentMouseEnter,
            onMouseLeave: onContentMouseLeave,
            onFocus: onContentMouseEnter,
            onBlur: onContentMouseLeave,
            className: (0, $gMc0m.default)([
                $255a0354b87c3a2a$var$styles.contentStyle,
                setOverflow && allowScrollBar && $255a0354b87c3a2a$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $255a0354b87c3a2a$var$styles.contentInteractiveActiveBorder
            ])
        }, children);
    };
    return /*#__PURE__*/ $42omo.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $255a0354b87c3a2a$var$styles.linkWrapper,
            inheritDimensions && $255a0354b87c3a2a$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $255a0354b87c3a2a$var$styles.linkWrapperSelected,
            showBackgroundAlways && $255a0354b87c3a2a$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $255a0354b87c3a2a$var$styles.linkWrapperInteractiveNotHidden,
            (0, $kVnOi.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        }
    }, renderHeader(), renderContent());
};
module.exports["ExpandedFrame"] = $255a0354b87c3a2a$export$7b360cd785b6c366;

});

parcelRegister("9CM6e", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dQl1W = parcelRequire("dQl1W");


var $bYRk6 = parcelRequire("bYRk6");


var $dh538 = parcelRequire("dh538");


var $lgqac = parcelRequire("lgqac");








var $5Tie7 = parcelRequire("5Tie7");

const $a1bc35c6199029b6$var$CardErrorBoundary = ({ children: children, ...props })=>{
    // TODO: NAVX-4682: Add feature parity to CardWithURLRenderer
    const ErrorFallbackComponent = props.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), props);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, children);
};
var $a1bc35c6199029b6$export$2e2bcd8739ae039 = $a1bc35c6199029b6$var$CardErrorBoundary;



var $aylI0 = parcelRequire("aylI0");




// SSR friendly version of smart-card
// simplifies the logic around rendering and loading placeholders and
// only contains whats necessary to render the card on SSR mode
const $21c8f9d8a5ab2bc3$var$CardSSROld = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const cardProps = {
        ...props,
        id: id
    };
    const ErrorFallbackComponent = cardProps.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Tie7.LoadingCardLink), cardProps);
    };
    const Component = cardProps.appearance === 'inline' ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: (0, $lgqac.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
        className: "loader-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrlContent), cardProps))));
};
// SSR friendly version of smart-card
// simplifies the logic around rendering and loading placeholders and
// only contains whats necessary to render the card on SSR mode
const $21c8f9d8a5ab2bc3$var$CardSSRNew = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const propsWithId = {
        ...props,
        id: id
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: (0, $lgqac.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1bc35c6199029b6$export$2e2bcd8739ae039), propsWithId, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aylI0.CardWithUrl), propsWithId)));
};
const $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6 = (props)=>{
    if ((0, $dh538.fg)('platform_sl_event_ui_seen')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c8f9d8a5ab2bc3$var$CardSSRNew, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($21c8f9d8a5ab2bc3$var$CardSSROld, props);
};
module.exports["CardSSR"] = $21c8f9d8a5ab2bc3$export$7b5e1b7f9a325b6;

});

parcelRegister("lwDWG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $bedQP = parcelRequire("bedQP");


var $90Y9A = parcelRequire("90Y9A");


var $dGcHs = parcelRequire("dGcHs");


var $ioVck = parcelRequire("ioVck");


var $f2jJp = parcelRequire("f2jJp");








var $8qPK2 = parcelRequire("8qPK2");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $1Whri = parcelRequire("1Whri");


var $cOQz3 = parcelRequire("cOQz3");


var $gdv5Z = parcelRequire("gdv5Z");

const $8894e3cbd66be38d$var$styles = {
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _19bv12x7 _u5f312x7",
    rovoIcon: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _ca0qv77o _n3tdv77o"
};
const $8894e3cbd66be38d$export$e99ddb02b43c6355 = ({ testId: testId })=>{
    return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($8894e3cbd66be38d$var$styles.innerContainer, $8894e3cbd66be38d$var$styles.rovoIcon),
        testId: testId
    }, /*#__PURE__*/ $42omo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cOQz3))), {
        label: "Rovo",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        size: "small"
    }));
};

















const $498c9281cd7395ce$var$LOZENGE_TEST_ID = 'inline-card-resolved-view-lozenge';
function $498c9281cd7395ce$export$69cf9880ad713b0e(lozenge) {
    if (!lozenge || !lozenge?.text) return null;
    if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
        if (stateMetricMatch) {
            const [, label, metric] = stateMetricMatch;
            const appearance = lozenge.appearance || 'neutral';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGcHs.default), {
                testId: $498c9281cd7395ce$var$LOZENGE_TEST_ID,
                appearance: appearance,
                style: {
                    backgroundColor: lozenge?.style?.backgroundColor,
                    color: lozenge?.style?.color
                },
                trailingMetric: metric
            }, label);
        }
    }
    const appearance = lozenge.appearance || 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGcHs.default), {
        testId: $498c9281cd7395ce$var$LOZENGE_TEST_ID,
        appearance: appearance,
        style: {
            backgroundColor: lozenge?.style?.backgroundColor,
            color: lozenge?.style?.color
        },
        isBold: lozenge.isBold !== false
    }, lozenge.text);
}


function $b903266f412bfc92$export$a75b7a22e5b9b36({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $498c9281cd7395ce$export$69cf9880ad713b0e)(lozenge));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}
function $b903266f412bfc92$export$9fc2dee105372861({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const { isEnabled: isEnabled } = (0, $8qPK2.default)(link, showHoverPreview, actionOptions);
    // TODO https://hello.jira.atlassian.cloud/browse/NAVX-4436: fire analytics with cohort
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $498c9281cd7395ce$export$69cf9880ad713b0e)(lozenge), isEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8894e3cbd66be38d$export$e99ddb02b43c6355), {
        testId: `${testId}-rovo-actions-cta`
    }));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}
const $b903266f412bfc92$export$4dcde1a6b9223e2e = (0, $bedQP.componentWithFG)('rovogrowth-640-inline-action-nudge-fg', $b903266f412bfc92$export$9fc2dee105372861, $b903266f412bfc92$export$a75b7a22e5b9b36);


class $1230500c958180f2$var$InlineCardResolvedViewClass extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge || !lozenge?.text) return null;
        if ((0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
            if (stateMetricMatch) {
                const [, label, metric] = stateMetricMatch;
                const appearance = lozenge.appearance || 'neutral';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGcHs.default), {
                    testId: "inline-card-resolved-view-lozenge",
                    appearance: appearance,
                    style: {
                        backgroundColor: lozenge?.style?.backgroundColor,
                        color: lozenge?.style?.color
                    },
                    trailingMetric: metric
                }, label);
            }
        }
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGcHs.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: lozenge.isBold !== false
        }, lozenge.text);
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            truncateInline: truncateInline
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
            emoji: titlePrefix,
            icon: icon,
            title: title,
            titleTextColor: titleTextColor,
            type: type,
            hideIconLoadingSkeleton: hideIconLoadingSkeleton
        }), this.renderLozenge());
        if (showHoverPreview && link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions
        }, inlineCardResolvedView);
        return inlineCardResolvedView;
    }
}
const $1230500c958180f2$export$6d5912cb4b56390e = (0, $bedQP.componentWithFG)('smart-card-inline-resolved-view-refactor', (0, $b903266f412bfc92$export$4dcde1a6b9223e2e), $1230500c958180f2$var$InlineCardResolvedViewClass);
module.exports["InlineCardResolvedView"] = $1230500c958180f2$export$6d5912cb4b56390e;

});

parcelRegister("k6YoH", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $a3fRD = parcelRequire("a3fRD");


var $afp1H = parcelRequire("afp1H");


var $90Y9A = parcelRequire("90Y9A");


var $7Vxvp = parcelRequire("7Vxvp");


var $ioVck = parcelRequire("ioVck");


var $f2jJp = parcelRequire("f2jJp");

const $cd173ed24f57420a$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        testId: "errored-view-default-icon"
    });
};
const $cd173ed24f57420a$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
            onClick: handleRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).try_again));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
        icon: icon || $cd173ed24f57420a$var$fallbackIcon(),
        link: hashAction ? url : undefined,
        title: url,
        onClick: hashAction ? onClick : undefined,
        rightSide: message
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        url: url
    }, content);
    return content;
};
module.exports["InlineCardErroredView"] = $cd173ed24f57420a$export$8ae570c871cdb179;

});

parcelRegister("0JrgF", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9Q2dU = parcelRequire("9Q2dU");


var $fVUfS = parcelRequire("fVUfS");


var $afp1H = parcelRequire("afp1H");


var $90Y9A = parcelRequire("90Y9A");


var $7Vxvp = parcelRequire("7Vxvp");


var $dGcHs = parcelRequire("dGcHs");


var $ioVck = parcelRequire("ioVck");


var $f2jJp = parcelRequire("f2jJp");

const $4678751d5fc36170$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $4678751d5fc36170$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "forbidden-view-fallback-icon"
    });
};
const $4678751d5fc36170$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $afp1H.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).invalid_permissions, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, formattedMessage));
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account"
            }, renderForbiddenAccessMessage());
        }
        if (onAuthorise) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
            xcss: $4678751d5fc36170$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dGcHs.default), {
            appearance: "moved",
            isBold: true
        }, renderForbiddenAccessMessage()));
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
        icon: icon ? icon : $4678751d5fc36170$var$fallbackForbiddenIcon(),
        link: url,
        title: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        url: url
    }, content);
    return content;
};
module.exports["InlineCardForbiddenView"] = $4678751d5fc36170$export$ebd227d2573ed3d8;

});

parcelRegister("ftXku", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $ioVck = parcelRequire("ioVck");


var $f2jJp = parcelRequire("f2jJp");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 



var $gMc0m = parcelRequire("gMc0m");

const $e68ee3db9bea97a6$export$91b164375b8037b5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});


const $e56cdb0d1ecfc871$var$styles = {
    spinnerWrapper: "_11c8wadc _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $e56cdb0d1ecfc871$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "span",
            xcss: $e56cdb0d1ecfc871$var$styles.spinnerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: 14,
            interactionName: "smart-card-inline-card-spinner"
        })), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconTitleWrapper), null, url, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e68ee3db9bea97a6$export$91b164375b8037b5), null, renderSpinner())));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
        icon: renderSpinner(),
        title: resolvingPlaceholder ?? url,
        titleTextColor: titleTextColor
    }));
};
module.exports["InlineCardResolvingView"] = $e56cdb0d1ecfc871$export$98531adac42f053e;

});

parcelRegister("51BZB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $fBMbo = parcelRequire("fBMbo");


var $9Q2dU = parcelRequire("9Q2dU");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");


var $1oCLl = parcelRequire("1oCLl");


var $kKODE = parcelRequire("kKODE");


var $afp1H = parcelRequire("afp1H");


var $6xy7N = parcelRequire("6xy7N");


var $90Y9A = parcelRequire("90Y9A");


var $7Vxvp = parcelRequire("7Vxvp");


var $ioVck = parcelRequire("ioVck");


var $f2jJp = parcelRequire("f2jJp");

const $addc63e9ffaeabd3$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    });
}; /**
    * When persisted personalization adoption from {@link getCachedProviderPctMapAndRefresh} is strictly below this value,
    * the pill uses exploratory "previewing" copy instead of a percentage headline.
    */ 
const $addc63e9ffaeabd3$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD = 30;
const $addc63e9ffaeabd3$var$SOCIAL_PROOF_TRAIT_NAME = 'sl_3p_connected_providers_site_pct';
const $addc63e9ffaeabd3$var$socialProofPillStyles = {
    strong: "_k48pwu06",
    inlineContainer: "_1e0c116y _4cvr1h6o",
    root: "_2rko12b0 _1e0c1nu9 _4cvr1h6o _vchhusvi _p12f1osq _bfhk1dpa _syazazsu _y3gn18uv _1wybtjj4 _s7n4t94y _ca0qv77o _n3tdv77o _u5f312x7 _19bv12x7 _2hwx1b66 _irr3plhp _1di61gdz",
    label: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    button: "_bfhk1j28 _u5f3ze3t _19bvze3t _ca0qze3t _n3tdze3t"
}; /**
    * Renders the social-proof pill and Connect button using persisted percentages only ({@link getCachedProviderPctMapAndRefresh}) — no
    * loading skeleton; either the cached percentage is shown or the legacy long connect label is used.
    *
    * Only mounted when the parent has passed the killswitch and
    * `platform_sl_3p_preauth_social_proof_inline_cta`. See platform docs: `rules-of-hooks.md` "Should §1".
    */ 
const $addc63e9ffaeabd3$var$UnauthorisedConnectWithSocialProof = ({ context: context, extensionKey: extensionKey, testId: testId, onConnectClick: onConnectClick })=>{
    (0, $fBMbo.di)((0, $6xy7N.getCachedProviderPctMapAndRefresh));
    const providerPctMap = (0, $6xy7N.getCachedProviderPctMapAndRefresh)($addc63e9ffaeabd3$var$SOCIAL_PROOF_TRAIT_NAME); // Will be false if this is the first render, when we fetch traits and store to local storage,
    // or if there wasn't our trait for it.
    const isProviderPctMapLoaded = providerPctMap !== null; // Percent of current user team (same tenant users) who are connected to this extension.
    const connectedPct = extensionKey && isProviderPctMapLoaded ? providerPctMap[extensionKey] : undefined;
    const trimmedProviderDisplayName = context?.trim() ?? '';
    const hasProviderDisplayName = trimmedProviderDisplayName.length > 0;
    const isSocialProofUsageHighEnough = connectedPct !== undefined && connectedPct >= $addc63e9ffaeabd3$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD; /**
                                                                                                                           * As long as trait is loaded we show the pill/lozange.
                                                                                                                           */ 
    const showSocialProofPill = providerPctMap !== null && (0, $1oCLl.expValEquals)('platform_sl_3p_preauth_social_proof_inline_cta', 'isEnabled', true);
    const bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            as: "strong",
            xcss: $addc63e9ffaeabd3$var$socialProofPillStyles.strong
        }, chunks); // As long as pill is shown it will be one of four messages depending on percent and provider presence:
    // - 45% of your team sees Figma previews
    // - 45% of your team sees richer previews
    // - Your team sees richer Figma previews
    // - Your team sees richer previews
    const socialProofPillContent = isSocialProofUsageHighEnough ? hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $afp1H.messages).social_proof_inline_cta_tag_high_with_context,
        values: {
            connectedPct: connectedPct,
            context: trimmedProviderDisplayName,
            b: bold
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $afp1H.messages).social_proof_inline_cta_tag_high_no_context,
        values: {
            connectedPct: connectedPct,
            b: bold
        }
    }) : hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $afp1H.messages).social_proof_inline_cta_tag_low_with_context,
        values: {
            context: trimmedProviderDisplayName
        }
    }) : // Unlikely case, but possible from TS standpoint.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).social_proof_inline_cta_tag_low_no_context);
    const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $addc63e9ffaeabd3$var$socialProofPillStyles.root,
        testId: `${testId}-social-proof-tag`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $addc63e9ffaeabd3$var$socialProofPillStyles.label
    }, socialProofPillContent)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
        onClick: onConnectClick,
        viewType: "unauthorised",
        testId: "button-connect-account",
        isSlimDesign: showSocialProofPill
    }, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $afp1H.messages).connect_inline_social_proof) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: context
        }
    })));
    return showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: onConnectClick,
        style: {
            font: `inherit`
        },
        xcss: $addc63e9ffaeabd3$var$socialProofPillStyles.button
    }, buttonContent) : buttonContent;
};
const $addc63e9ffaeabd3$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context, extensionKey: extensionKey })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
            onClick: handleConnectAccount,
            viewType: 'unauthorised',
            testId: "button-connect-account"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...(0, $afp1H.messages).connect_link_account_card_name,
            values: {
                context: context
            }
        }));
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ioVck.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        viewType: "unauthorised"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f2jJp.IconAndTitleLayout), {
        icon: icon ? icon : $addc63e9ffaeabd3$var$fallbackUnauthorizedIcon(),
        title: url,
        link: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), onAuthorise && ((0, $dh538.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($addc63e9ffaeabd3$var$UnauthorisedConnectWithSocialProof, {
        context: context,
        extensionKey: extensionKey,
        testId: testId,
        onConnectClick: handleConnectAccount
    }) : renderActionButton()));
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $90Y9A.HoverCard), {
        url: url,
        id: id
    }, inlineCardUnauthenticatedView);
    return inlineCardUnauthenticatedView;
};
module.exports["InlineCardUnauthorizedView"] = $addc63e9ffaeabd3$export$ece47728c0503997;

});

parcelRegister("izGro", function(module, exports) {
const $c3bb25ce30f1793a$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};
module.exports["handleClickCommon"] = $c3bb25ce30f1793a$export$9759a67e215c4598;

});

parcelRegister("kVnOi", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");

const $3da5dd2acb364266$export$2913c0c0b5623090 = 'media-card-frame';
const $3da5dd2acb364266$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
const $3da5dd2acb364266$export$3e431a229df88919 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $7sObp.default)($3da5dd2acb364266$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $3da5dd2acb364266$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $7sObp.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkizff _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});
module.exports["className"] = $3da5dd2acb364266$export$2913c0c0b5623090;
module.exports["Image"] = $3da5dd2acb364266$export$3e431a229df88919;

});

parcelRegister("f2jJp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fBMbo = parcelRequire("fBMbo");


var $6Eovk = parcelRequire("6Eovk");


var $1bY7o = parcelRequire("1bY7o");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $ivUmx = parcelRequire("ivUmx");


var $bqU8y = parcelRequire("bqU8y");

const $66fd2ed055f5d465$var$iconWrapperStyle = null;
const $66fd2ed055f5d465$var$iconImageStyle = null;
const $66fd2ed055f5d465$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz1rpy _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
const $66fd2ed055f5d465$var$LinkAppearance = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syaz13af _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $66fd2ed055f5d465$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $42omo.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            if (emoji) return emoji;
            if (!icon || typeof icon === 'string' || Array.isArray(icon)) return null;
            return icon;
        } else {
            if (emoji) return emoji;
            if (!icon || typeof icon === 'string') return null;
            return icon;
        }
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $ivUmx.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((errored, testId)=>{
        (0, $fBMbo.di)((0, $6Eovk.default));
        if ((0, $dh538.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            if (!icon) return null;
            let iconUrl;
            let iconLabel = '';
            if (Array.isArray(icon)) {
                const [tupleIconUrl, tupleIconLabel] = icon;
                if (typeof tupleIconUrl !== 'string') return null;
                iconUrl = tupleIconUrl;
                iconLabel = typeof tupleIconLabel === 'string' ? tupleIconLabel : '';
            } else if (typeof icon === 'string') iconUrl = icon;
            else return null;
            if (hideIconLoadingSkeleton) {
                if (hasImageErrored) return errored;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    src: iconUrl,
                    "data-testid": `${testId}-image`,
                    alt: iconLabel,
                    onError: ()=>setHasImageErrored(true),
                    className: (0, $gMc0m.default)([
                        "_c71l7vkz _p12f7vkz _1bsb1osq",
                        profileType && $66fd2ed055f5d465$var$styles.roundImageStyle
                    ])
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Eovk.default), {
                src: iconUrl,
                loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    src: iconUrl,
                    "data-testid": `${testId}-image`,
                    alt: iconLabel,
                    className: (0, $gMc0m.default)([
                        "_c71l7vkz _p12f7vkz _1bsb1osq",
                        profileType && $66fd2ed055f5d465$var$styles.roundImageStyle
                    ])
                }),
                errored: errored,
                loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqU8y.Shimmer), {
                    testId: `${testId}-loading`
                })
            });
        } else {
            if (!icon || typeof icon !== 'string') return null;
            if (hideIconLoadingSkeleton) {
                if (hasImageErrored) return errored;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    src: icon,
                    "data-testid": `${testId}-image`,
                    alt: "",
                    onError: ()=>setHasImageErrored(true),
                    className: (0, $gMc0m.default)([
                        "_c71l7vkz _p12f7vkz _1bsb1osq",
                        profileType && $66fd2ed055f5d465$var$styles.roundImageStyle
                    ])
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Eovk.default), {
                src: icon,
                loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    src: icon,
                    "data-testid": `${testId}-image`,
                    alt: "",
                    className: (0, $gMc0m.default)([
                        "_c71l7vkz _p12f7vkz _1bsb1osq",
                        profileType && $66fd2ed055f5d465$var$styles.roundImageStyle
                    ])
                }),
                errored: errored,
                loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqU8y.Shimmer), {
                    testId: `${testId}-loading`
                })
            });
        }
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: "link",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]); // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        // We cannot set the fix font because inline is taking the parent container font size into account.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        style: {
            lineHeight: `1`
        },
        xcss: $66fd2ed055f5d465$var$styles.iconOuterWrapperStyle,
        testId: "icon-position-wrapper"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $66fd2ed055f5d465$var$styles.iconEmptyStyle,
        testId: "icon-empty-wrapper"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "icon-wrapper",
        className: (0, $gMc0m.default)([
            "_11c8wadc _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
        ])
    }, renderIcon(testId)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        style: {
            color: titleTextColor
        }
    }, title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66fd2ed055f5d465$export$c73a53738ef9e3f, {
        style: {
            color: titleColor
        },
        testId: testId
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($66fd2ed055f5d465$var$LinkAppearance, {
        href: link,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        className: (0, $gMc0m.default)([
            $66fd2ed055f5d465$var$styles.linkStyle
        ])
    }, titlePart) : titlePart, rightSide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $66fd2ed055f5d465$var$styles.noLinkAppearanceStyle
    }, rightSide) : null));
};
const $66fd2ed055f5d465$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "span",
        xcss: $66fd2ed055f5d465$var$styles.iconTitleWrapperStyle,
        ...props
    });
};
module.exports["IconAndTitleLayout"] = $66fd2ed055f5d465$export$d34be4d513116847;
module.exports["IconTitleWrapper"] = $66fd2ed055f5d465$export$c73a53738ef9e3f;

});

parcelRegister("7Vxvp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

const $fee91c6d88bcaa54$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    innerContainerSocialProofConnect: "_2rko12b0 _syaz15cr _80omtlke _bfhkjmqp _2hwxv77o _1e0c1nu9 _4cvr1h6o _1wybtjj4 _1y1m1u8q _16d9qvcn _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _s7n4t94y _o5721btx _1nmz9jpi _irr31q28 _1di612kk",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhk187o",
    unauthorised: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk"
}; /* eslint-enable @compiled/shorthand-property-sorting */ 
const $fee91c6d88bcaa54$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', isSlimDesign: isSlimDesign = false, ...props }, ref)=>{
    const shouldUseUnauthorisedSlimStyle = viewType === 'unauthorised' && isSlimDesign && (0, $dh538.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch');
    if (shouldUseUnauthorisedSlimStyle && !isDisabled) {
        const { onClick: onClick, ...boxProps } = props;
        return /*#__PURE__*/ $42omo.createElement((0, $gdv5Z.default), {
            ...boxProps,
            ref: ref,
            style: {
                font: `inherit`
            },
            xcss: $fee91c6d88bcaa54$var$styles.button
        }, /*#__PURE__*/ $42omo.createElement("span", {
            className: (0, $gMc0m.default)([
                $fee91c6d88bcaa54$var$styles.innerContainerSocialProofConnect
            ])
        }, children));
    }
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $fee91c6d88bcaa54$var$styles.button
    }, /*#__PURE__*/ $42omo.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $gMc0m.default)([
            $fee91c6d88bcaa54$var$styles.innerContainer,
            isDisabled ? $fee91c6d88bcaa54$var$styles.disabled : viewType === 'unauthorised' ? $fee91c6d88bcaa54$var$styles.unauthorised : $fee91c6d88bcaa54$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $fee91c6d88bcaa54$export$cfc7921d29ef7b80;

});

parcelRegister("dGcHs", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

const $770b0e8ed2d89455$var$wrapperStylesOld = null;
const $770b0e8ed2d89455$var$wrapperStylesNew = null;
const $770b0e8ed2d89455$var$wrapperStylesNewLozenge = null;
const $770b0e8ed2d89455$var$InlineLozenge = (props)=>{
    const shouldAddLozengeAttribute = (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp');
    if ((0, $dh538.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ $42omo.createElement("span", {
        ...shouldAddLozengeAttribute && {
            'data-inline-card-lozenge': true
        },
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _154i1n1a _kqswh2mm _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq",
            (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_2hwxt94y"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), props));
    return /*#__PURE__*/ $42omo.createElement("span", {
        ...shouldAddLozengeAttribute && {
            'data-inline-card-lozenge': true
        },
        className: (0, $gMc0m.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq",
            (0, $dh538.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_2hwxt94y"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $5nBzc.default), props));
};
var $770b0e8ed2d89455$export$2e2bcd8739ae039 = $770b0e8ed2d89455$var$InlineLozenge;
module.exports["default"] = $770b0e8ed2d89455$export$2e2bcd8739ae039;

});

parcelRegister("6xy7N", function(module, exports) {

var $kt8c2 = parcelRequire("kt8c2");


var $bIwjt = parcelRequire("bIwjt");

const $95081e79a5e223a6$var$BASE_URL = '/gateway/api/tap-delivery/api/v3/personalization';
const $95081e79a5e223a6$export$2f936a88fd429e8c = 'smart-card-social-proof';
const $95081e79a5e223a6$export$93b4593f39ac22dc = 'pct-map:v1:';
const $95081e79a5e223a6$export$d8f80dc0b98f1c37 = 86400000;
const $95081e79a5e223a6$export$eb1c7e303b49fcc6 = 'sl_3p_connected_providers_site_pct';
const $95081e79a5e223a6$var$smartCardStorage = new (0, $kt8c2.default)($95081e79a5e223a6$export$2f936a88fd429e8c);
/** Keys written by this service in localStorage when using {@link smartCardStorage}. */ const $95081e79a5e223a6$var$LOCAL_STORAGE_ROW_KEY_PREFIX = `${$95081e79a5e223a6$export$2f936a88fd429e8c}_${$95081e79a5e223a6$export$93b4593f39ac22dc}`;
function $95081e79a5e223a6$var$scopedCacheKey(cloudId, traitName) {
    return `${cloudId}:${traitName}`;
}
function $95081e79a5e223a6$var$pctMapStorageItemKey(cloudId, traitName) {
    return `${$95081e79a5e223a6$export$93b4593f39ac22dc}${encodeURIComponent(cloudId)}:${encodeURIComponent(traitName)}`;
}
async function $95081e79a5e223a6$var$fetchSiteTraits(cloudId) {
    const response = await fetch(`${$95081e79a5e223a6$var$BASE_URL}/site/${cloudId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data?.attributes ?? [];
}
class $95081e79a5e223a6$export$d653d8abac1e12ce {
    /** Pure synchronous read for an explicit cloud id / trait pair. */ getProviderPctMapSync(cloudId, traitName) {
        if (!cloudId) return null;
        return this.readStoredProviderPctMap(cloudId, traitName);
    }
    async getProviderPctMap(cloudId, traitName) {
        if (!cloudId) return undefined;
        const cacheKey = $95081e79a5e223a6$var$scopedCacheKey(cloudId, traitName);
        const cachedPromise = this.cache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                const traits = await $95081e79a5e223a6$var$fetchSiteTraits(cloudId);
                const trait = traits.find((t)=>t.name === traitName);
                const mapped = this.parseTraitValue(trait?.value);
                if (mapped !== undefined) this.writeStoredProviderPctMap(cloudId, traitName, mapped);
                return mapped;
            } catch  {
                return undefined;
            }
        })();
        const retryablePromise = promise.finally(()=>{
            this.cache.delete(cacheKey);
        });
        this.cache.set(cacheKey, retryablePromise);
        return retryablePromise;
    }
    readStoredProviderPctMap(cloudId, traitName) {
        try {
            const stored = $95081e79a5e223a6$var$smartCardStorage.getItem($95081e79a5e223a6$var$pctMapStorageItemKey(cloudId, traitName));
            if (stored === undefined || stored === null) return null;
            return this.normalizeProviderPctMap(stored);
        } catch  {
            return null;
        }
    }
    writeStoredProviderPctMap(cloudId, traitName, map) {
        try {
            $95081e79a5e223a6$var$smartCardStorage.setItemWithExpiry($95081e79a5e223a6$var$pctMapStorageItemKey(cloudId, traitName), map, $95081e79a5e223a6$export$d8f80dc0b98f1c37);
        } catch  {
        // Quota, private-mode, etc.
        }
    }
    normalizeProviderPctMap(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
        const map = {};
        const entries = Object.entries(value);
        for (const [providerKey, percentageRaw] of entries){
            if (typeof percentageRaw !== 'number' || !Number.isFinite(percentageRaw)) return null;
            map[providerKey] = percentageRaw;
        }
        return map;
    }
    parseTraitValue(raw) {
        if (typeof raw !== 'string') return undefined;
        try {
            const parsed = JSON.parse(raw);
            const normalized = this.normalizeProviderPctMap(parsed);
            return normalized === null ? undefined : normalized;
        } catch  {
            return undefined;
        }
    }
    clearCache() {
        this.cache.clear();
        this.clearStoredProviderPctMaps();
    }
    clearStoredProviderPctMaps() {
        if (typeof globalThis.localStorage === 'undefined' || globalThis.localStorage === null) return;
        const keysToRemove = [];
        for(let index = 0; index < globalThis.localStorage.length; index += 1){
            const key = globalThis.localStorage.key(index);
            if (key !== null && key.startsWith($95081e79a5e223a6$var$LOCAL_STORAGE_ROW_KEY_PREFIX)) keysToRemove.push(key);
        }
        for (const key of keysToRemove)try {
            globalThis.localStorage.removeItem(key);
        } catch  {
        /* ignore */ }
    }
    constructor(){
        this.cache = new Map();
    }
}
const $95081e79a5e223a6$export$356056318a4fd636 = new $95081e79a5e223a6$export$d653d8abac1e12ce();
const $95081e79a5e223a6$export$fed0d3ced5218947 = (cloudId, traitName)=>$95081e79a5e223a6$export$356056318a4fd636.getProviderPctMap(cloudId, traitName);
function $95081e79a5e223a6$export$70435023d0d90129(cloudId, traitName) {
    return $95081e79a5e223a6$export$356056318a4fd636.getProviderPctMapSync(cloudId, traitName);
}
function $95081e79a5e223a6$export$63f5703c889fdfe6(traitName) {
    const cloudId = (0, $bIwjt.getCurrentSiteCloudIdSync)();
    const providerPctMap = $95081e79a5e223a6$export$70435023d0d90129(cloudId, traitName);
    (0, $bIwjt.getCurrentSiteCloudId)().then((resolvedCloudId)=>{
        $95081e79a5e223a6$export$fed0d3ced5218947(resolvedCloudId, traitName);
    });
    return providerPctMap;
}
module.exports["SOCIAL_PROOF_TRAIT_NAME"] = $95081e79a5e223a6$export$eb1c7e303b49fcc6;
module.exports["getProviderPctMap"] = $95081e79a5e223a6$export$fed0d3ced5218947;
module.exports["getProviderPctMapSync"] = $95081e79a5e223a6$export$70435023d0d90129;
module.exports["getCachedProviderPctMapAndRefresh"] = $95081e79a5e223a6$export$63f5703c889fdfe6;

});

parcelRegister("bqU8y", function(module, exports) {
/* Icon.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4vCA9 = parcelRequire("4vCA9");

const $4c6c4d2cce4bffd9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $4c6c4d2cce4bffd9$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4vCA9.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: 2,
        testId: testId,
        style: skeletonCustomStyles
    });
};
module.exports["Shimmer"] = $4c6c4d2cce4bffd9$export$809644b82cfe94b1;

});


$parcel$global.rlb("6EuUL")
//# sourceMappingURL=FullPageEditorComponent.884bdca8.js.map
